import React, { Component, useEffect } from 'react';
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse, handleLeft, skipBusinessDayOverrideWarning } from '../../../Actions/AllAction';
import { setCurrentStore, setStoresFetched, setStores } from '../../../Actions/StoreActions';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faCheckCircle, faTimesCircle, faExclamationTriangle, faClock, faPlus, faSync, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import { setToken, logOutApp, setUserCredentials, setUserEntryType } from '../../Login/Actions/LoginAction';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Alert from 'react-bootstrap/Alert';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import CustomInput from '../Components/CustomInput';
import * as UtilityController from '../Controller/UtilityController';
import ModalGlobal from './ModalGlobal';
import ConfirmationAlert from './ConfirmationAlert';
import CloseRegisterModal from '../../../V4/Modules/Order/Components/OrderFormComponents/CloseRegisterModal';
import OpenRegistersCloseModal from './OpenRegistersCloseModal';
import NightAuditCheckpointsModal from './NightAuditCheckpointsModal';
import { getActiveBusinessRegister, getRegisterOrderAmount, fetchAllOpenRegisters, closeAllBusinessRegisters } from '../../../V4/Modules/BusinessRegister/Controller/BusinessRegisterController';
import ChangePasswordContent from './ChangePasswordContent';
import AutosuggestComponent from '../Components/AutosuggestComponent';
import StoreSwitcherSelect from '../Components/StoreSwitcherSelect';
import { withNamespaces } from 'react-i18next';
import UserProfile from '../../UserProfile/Pages/UserProfile'
import Tooltip from 'react-bootstrap/Tooltip';
import AlertNotification from './AlertNotification';
import Utility from '../Utility';
import EventEmitter from '../EventEmitter';
import { getCurrentUser } from '../../Login/Controller/LoginController';
import * as StoreController from '../Controller/StoreController';
import { invalidateApiCache } from '../Http';
import { withRouter } from 'react-router-dom';
import '../Public/css/headerdoc.scss';
import { getOrderPrerequisitesChecklist } from '../../../V4/Modules/Order/Controller/ChecklistController';
import IsEligibleToShow from './IsEligibleToShow';
import ErrorBoundary from './ErrorBoundary';

// Map prerequisite module names to their setup/configuration routes
const PREREQUISITE_ROUTES = {
	'Supplier': '/supplier/list',
	'Product': '/stock/products',
	'Category': '/category',
	'Tax': '/tax-codes',
	'Payment Method': '/settings/payment-methods',
	'Billing Counter': '/settings/billing-counters',
	'Store': '/settings/stores',
	'Business Register': '/business/registers',
	'Account': '/business/accounts',
	'Discount': '/discount-codes',
	'Addon Group': '/stock/addon-groups',
};


const channel = new BroadcastChannel('foobar');
const BUSINESS_DAY_OVERDUE_STORAGE_KEY = 'businessDayOverdueEvent';

class Header extends Component {
	constructor(props) {
		super(props)
		this.handleBar = this.handleBar.bind(this);
		// Hydrate business day from cache so the header button renders instantly;
		// checkCurrentBusinessDay reconciles against the API afterwards
		let cachedBusinessDayInfo = null;
		try {
			cachedBusinessDayInfo = JSON.parse(localStorage.getItem('businessDayInfo') || 'null');
		} catch (e) {
			cachedBusinessDayInfo = null;
		}
		this.state = {
			subheaderShow: true,
			windowWidth: window.innerWidth,
			changePasswordModalOpen: false,
			tabchangeParent: false,
			formData: {
				userEmail: "",
				password: "",
				newPassword: "",
				confirmPassword: ""
			},
			errorData: {
				userEmailError: "",
				passwordError: "",
				newPasswordError: "",
				confirmPasswordError: ""
			},

			limit: 10,
			offset: 0,
			notificationsData: [],
			showLoadmore: false,
			showPopup: false,
			notificationVisible: false,
			langaugeConfirmModal: false,
			selectedLangauge: '',
			changePasswordFlag: false,
			unreadNotificationCount: 0,
			showReadAllConfirmModal: false,
			versionOption: [],
			selectedVersionValue: [],

			//alert notification
			show: true,
			notificationData: [{ message: "Your subscription is ended.", "id": 0 }],
			zoominzoomoutflag: "",
			myProfileModalFlag: false,
			isLogout: false,

			// Business Day
			businessDayOpen: !!cachedBusinessDayInfo,
			businessDayInfo: cachedBusinessDayInfo,
			businessDayLoading: false,
			showOpenBusinessDayModal: false,

			// Prerequisites checklist
			prerequisitesChecklist: {},
			prerequisitesLoading: false,
			showPrerequisitesPopup: false,
			prerequisitesMissing: false,
			showMobileSwitchPanel: false,

			// Business Day Override Modal
			showOverrideModal: false,
			overrideAllowCancel: false,
			warningShown: false,

			// PMS Sync Modal
			showPmsSyncModal: false,
			pmsSyncLoading: false,
			overrideLoading: false,
			overrideFormData: {
				override_hours: '00',
				override_minutes: '00',
				override_reason: ''
			},
			overrideErrors: {
				override_reason: ''
			},

			// Close Register Modal
			showCloseRegisterModal: false,
			closeRegisterMode: 'close',
			registerData: null,

			// Business Day Confirmation Modal
			businessdayConfirmModal: false,
			businessDayConfirmMessage: "Are you sure you want to close the business day?",
			hasActiveRegister: false,
			closeDayShowFlag: false,

			// Pending Orders Modal
			showPendingOrdersModal: false,
			pendingOrdersCount: 0,

			// Open Registers Modal
			showOpenRegistersModal: false,
			openRegistersList: [],
			autoClosingRegisters: false,
			currentBusinessDayId: null,

			// Advance Night Audit Modal
			showNightAuditModal: false,
			nightAuditLoading: false,
			nightAuditCheckpointsData: null,
			nightAuditClosing: false
		}
		this.codeOutsideClickRef = React.createRef();
	}

	toggleMobileSwitchPanel = () => {
		this.setState(prev => ({ showMobileSwitchPanel: !prev.showMobileSwitchPanel }));
	};

	closeMobileSwitchPanel = () => {
		this.setState({ showMobileSwitchPanel: false });
	};

	checkEligibilityToShow = (eventKey) => {
		const { currentStore } = this.props;
		let storeDetails = currentStore ? { "store_type": currentStore.store_type, "is_procurement_hub": currentStore.is_procurement_hub, "can_sell": currentStore.can_sell } : { "store_type": null, "is_procurement_hub": false, "can_sell": false };
		const orgDetails = { "allow_main_store": currentStore?.orgMetaStoreRelation?.allow_main_store };
		let IsEligibleToShowTab = IsEligibleToShow(eventKey, storeDetails, orgDetails);
		// console.log(`Eligibility for ${eventKey}:`, IsEligibleToShowTab);
		return IsEligibleToShowTab;
	};
	// Start Business Day functions
	openBusinessDay = () => {
		this.setState({ showOpenBusinessDayModal: true });
	};

	confirmOpenBusinessDay = async () => {
		const { currentStore } = this.props;
		if (!currentStore?.id) {
			Utility.toastNotifications('Please select a store first', "Error", "error");
			return;
		}

		this.setState({ businessDayLoading: true });

		try {
			const response = await UtilityController.businessDay({
				store_id: currentStore.id
			});

			if (response.success) {
				this.setState({
					businessDayOpen: true,
					businessDayInfo: response.data,
					business_date: response.data.business_date
				});
				// Store business day info in localStorage for cross-component access
				localStorage.setItem('businessDayInfo', JSON.stringify(response.data));

				// Start countdown timer if planned_closed_at is available
				if (response.data && response.data.planned_closed_at) {
					this.startCountdown(response.data.planned_closed_at);
				}
				// Notify other tabs that business day was opened
				channel.postMessage({ businessDayAction: 'opened' });
				Utility.toastNotifications('Business day opened successfully', "Success", "success");
			} else {
				Utility.toastNotifications(response.message || 'Failed to open business day', "Error", "error");
			}
		} catch (error) {
			console.error('Error opening business day:', error);
			Utility.toastNotifications('An error occurred while opening business day', "Error", "error");
		} finally {
			this.setState({ businessDayLoading: false });
			this.closeOpenBusinessDayModal();
		}
	};

	closeOpenBusinessDayModal = () => {
		this.setState({ showOpenBusinessDayModal: false });
	};

	closeBusinessDay = () => {
		const { currentStore } = this.props;
		const isSellingStore = Utility.isChkBusinessDay(currentStore);

		if (isSellingStore) {
			this.openNightAuditModal();
		} else {
			// Check register status and show appropriate confirmation modal for non-selling store
			this.confirmCloseBusinessDay();
		}
	};

	openNightAuditModal = async () => {
		const storeId = this.props.currentStore?.id || localStorage.getItem("store_id");
		this.setState({
			showNightAuditModal: true,
			nightAuditLoading: true,
			nightAuditCheckpointsData: null
		});

		try {
			const response = await UtilityController.getNightAuditCheckpoints({ store_id: storeId });
			if (response && response.success) {
				this.setState({
					nightAuditCheckpointsData: response,
					nightAuditLoading: false
				});
			} else {
				this.setState({ nightAuditLoading: false });
				Utility.toastNotifications(response?.message || 'Failed to fetch checkpoints', 'Error', 'error');
			}
		} catch (error) {
			console.error('Error fetching night audit checkpoints:', error);
			this.setState({ nightAuditLoading: false });
			Utility.toastNotifications('Failed to load night audit checkpoints', 'Error', 'error');
		}
	};

	handleNightAuditConfirmClose = async (payload) => {
		this.setState({ nightAuditClosing: true });
		try {
			const storeId = this.props.currentStore?.id || localStorage.getItem("store_id");
			const businessDayId = this.state.nightAuditCheckpointsData?.business_day?.id || this.state.currentBusinessDayId;

			// If any open registers were filled in the modal, close them first
			if (payload.registers && payload.registers.length > 0) {
				const openRegsToClose = payload.registers.filter(r => {
					const regDetails = this.state.nightAuditCheckpointsData?.tiers?.tier2_registers?.details?.registers?.find(x => x.register_id === r.register_id);
					return regDetails && regDetails.is_open;
				});

				if (openRegsToClose.length > 0) {
					const closeRegsResult = await closeAllBusinessRegisters({
						store_id: storeId,
						business_day_id: businessDayId,
						registers: openRegsToClose
					});

					if (!closeRegsResult.success) {
						this.setState({ nightAuditClosing: false });
						Utility.toastNotifications(closeRegsResult.message || 'Failed to close open registers', 'Error', 'error');
						return;
					}
				}
			}

			// Call close business day directly with manager override info
			await this.closeBusinessDayDirectly({
				manager_override: payload.manager_override,
				override_reason: payload.override_reason
			});

			this.setState({
				showNightAuditModal: false,
				nightAuditClosing: false,
				nightAuditCheckpointsData: null
			});
		} catch (error) {
			console.error('Error closing business day with audit:', error);
			this.setState({ nightAuditClosing: false });
			Utility.toastNotifications(error.message || 'Failed to close business day', 'Error', 'error');
		}
	};

	confirmCloseBusinessDay = async () => {
		// First check for pending orders
		try {
			const storeId = this.props.currentStore?.id || localStorage.getItem("store_id");

			let param = {
				"store_id": storeId
			};
			let filters = {};
			filters['filters'] = JSON.stringify(param);
			const businessDayResponse = await UtilityController.getCurrentBusinessDay(filters);

			let businessDayId = null;
			if (businessDayResponse.success && businessDayResponse.data && businessDayResponse.data.length > 0) {
				const businessDay = businessDayResponse.data[0];
				businessDayId = businessDay.id || businessDay.slack || null;
				this.setState({ currentBusinessDayId: businessDayId });

				// Check if there are business_day_orders with status 5 (settled orders)
				if (businessDay.business_day_orders && businessDay.business_day_orders.length > 0) {
					this.setState({
						showPendingOrdersModal: true,
						pendingOrdersCount: businessDay.business_day_orders.length
					});
					return; // Don't proceed with business day closing
				}
			}

			// No pending orders found, proceed with open registers check
			if (businessDayId) {
				const eligibility = await fetchAllOpenRegisters(storeId, businessDayId);
				if (eligibility.success && eligibility.hasOpenRegisters) {
					// Open registers found - show warning modal with register details
					this.setState({
						showOpenRegistersModal: true,
						openRegistersList: eligibility.openRegisters
					});
					return;
				}
			}

			// No open registers found - show simple business day closing confirmation
			this.setState({
				businessDayConfirmMessage: "Are you sure you want to close the business day?",
				hasActiveRegister: false,
				businessdayConfirmModal: true
			});

		} catch (error) {
			console.error('Error checking business day close eligibility:', error);
			// On error, show simple message and proceed
			this.setState({
				businessDayConfirmMessage: "Are you sure you want to close the business day?",
				hasActiveRegister: false,
				businessdayConfirmModal: true
			});
		}
	};

	executeCloseBusinessDay = async () => {
		this.setState({ businessdayConfirmModal: false });
		await this.closeBusinessDayDirectly();
	};

	closeBusinessDayDirectly = async (extraParams = {}) => {
		this.setState({ businessDayLoading: true });

		try {
			const storeId = this.props.currentStore?.id || localStorage.getItem("store_id");
			const payload = {
				store_id: storeId,
				...(extraParams || {})
			};
			const response = await UtilityController.businessDayClose(payload);

			if (response.success) {
				this.setState({
					businessDayOpen: false,
					businessDayInfo: null,
					business_date: null,
					showCloseRegisterModal: false,
					showNightAuditModal: false
				});
				// Remove business day info from localStorage when closing
				localStorage.removeItem('businessDayInfo');
				// Stop countdown timer when closing business day
				this.stopCountdown();
				// Notify other tabs that business day was closed
				channel.postMessage({ businessDayAction: 'closed' });
				Utility.toastNotifications('Business day closed successfully', "Success", "success");
				if (response.data && response.data.business_date) {
					const businessDate = response.data.business_date;
					window.location.href = `/#/en-US/reports/night-audit-report?date=${businessDate}`;
				}

			} else {
				Utility.toastNotifications(response.message || 'Failed to close business day', "Error", "error");
			}
		} catch (error) {
			console.error('Error closing business day:', error);
			Utility.toastNotifications(error.response?.data?.message || error.message || 'An error occurred while closing business day', "Error", "error");
		} finally {
			this.setState({ businessDayLoading: false, nightAuditClosing: false });
		}
	};

	fetchRegisterOrderAmount = async () => {
		try {
			const storeId = localStorage.getItem("store_id");
			const result = await getRegisterOrderAmount(storeId);

			if (result.success) {
				// Update registerData with the fetched order amount
				this.setState(prevState => ({
					registerData: {
						...prevState.registerData,
						orderAmount: result.amount
					}
				}));
			} else {
				console.error('Failed to fetch register order amount:', result.message);
			}
		} catch (error) {
			console.error('Error fetching register order amount:', error);
		}
	};

	cancelCloseBusinessDay = () => {
		this.setState({ businessdayConfirmModal: false });
	};

	// Pending Orders Modal Handlers
	handleGoToTableView = () => {
		// const { lng } = this.props;
		this.setState({ showPendingOrdersModal: false });
		const lng = this.props.i18n && this.props.i18n.language ? this.props.i18n.language : (localStorage.getItem('i18nextLng') || 'en');
		const targetPath = `/${lng}/sales/orders/add`;
		if (!this.props.location.pathname.includes(targetPath)) {
			this.props.history.push(targetPath);
		}
	};

	handleCancelPendingOrders = () => {
		this.setState({ showPendingOrdersModal: false });
	};

	// Open Registers Modal Handlers
	cancelOpenRegistersModal = () => {
		this.setState({
			showOpenRegistersModal: false,
			openRegistersList: [],
			autoClosingRegisters: false
		});
	};

	confirmAutoCloseRegisters = async ({ reason, registerInputs }) => {
		this.setState({ autoClosingRegisters: true });

		try {
			const storeId = this.props.currentStore?.id || localStorage.getItem("store_id");
			const businessDayId = this.state.currentBusinessDayId;

			const payload = {
				store_id: storeId,
				business_day_id: businessDayId,
				registers: registerInputs.map((input) => ({
					register_id: input.id,
					closing_amount: Number(input.closing_amount),
					credit_card_slips: Number(input.credit_card_slips),
					cheques: Number(input.cheques),
					expected_closing_amount: Number(input.expected_closing_amount || input.closing_amount),
					close_note: reason
				}))
			};

			// Step 1: Close all open registers
			const result = await closeAllBusinessRegisters(payload);

			if (!result.success) {
				this.setState({ autoClosingRegisters: false });
				Utility.toastNotifications(result.message || 'Failed to close registers', 'Error', 'error');
				return;
			}

			// Step 2: On success, close the business day
			await this.closeBusinessDayDirectly();

			// Step 3: Both succeeded — clear modal state
			this.setState({
				showOpenRegistersModal: false,
				autoClosingRegisters: false,
				openRegistersList: [],
				currentBusinessDayId: null
			});

			Utility.toastNotifications('Business day and all open registers closed successfully', 'Success', 'success');
		} catch (error) {
			console.error('Error auto-closing registers:', error);
			this.setState({ autoClosingRegisters: false });
			Utility.toastNotifications('Failed to close open registers. Please close them manually.', 'Error', 'error');
		}
	};

	handleCloseRegisterModalHide = async (registerClosedSuccessfully = false) => {
		// Hide the modal
		this.setState({ showCloseRegisterModal: false });

		// Only close business day if register was successfully closed
		if (registerClosedSuccessfully) {
			await this.closeBusinessDayDirectly();
		}
	};

	closeBusinessDayAfterRegister = async () => {
		// This method is kept for backward compatibility but now delegates to handleCloseRegisterModalHide
		await this.handleCloseRegisterModalHide(true);
	};

	checkCurrentBusinessDay = async () => {
		const { currentStore } = this.props;
		if (!currentStore?.id) {
			return;
		}
		// Release the open-day button gate as soon as the real status resolves
		// instead of waiting for the fixed 5s timer (kept as a fallback)
		this.setState({ closeDayShowFlag: true });

		try {
			let param = {}
			param = {
				"store_id": localStorage.getItem("store_id")
			};

			let filters = {};
			filters['filters'] = JSON.stringify(param);
			const response = await UtilityController.getCurrentBusinessDay(filters);

			if (response.success && response.data && response.data.length > 0) {
				const businessDay = response.data[0];
				this.setState({ business_date: businessDay?.business_date });
				if (businessDay.status === "OPEN") {
					this.setState({
						businessDayOpen: true,
						businessDayInfo: businessDay
					});
					// Store business day info in localStorage for cross-component access
					localStorage.setItem('businessDayInfo', JSON.stringify(businessDay));
					// Start countdown timer if planned_closed_at is available
					if (businessDay.planned_closed_at) {
						this.startCountdown(businessDay.planned_closed_at);
					}
				} else {
					this.setState({
						businessDayOpen: false,
						businessDayInfo: null,
						business_date: null
					});
					// Remove business day info from localStorage when closed
					localStorage.removeItem('businessDayInfo');
					this.stopCountdown();
				}
			} else {
				this.setState({
					businessDayOpen: false,
					businessDayInfo: null,
					business_date: null
				});
				// Remove business day info from localStorage when no active business day
				localStorage.removeItem('businessDayInfo');
				this.stopCountdown();
			}
		} catch (error) {
			console.error('Error checking current business day:', error);
			this.setState({
				businessDayOpen: false,
				businessDayInfo: null,
				business_date: null
			});
			// Remove business day info from localStorage on error
			localStorage.removeItem('businessDayInfo');
			this.stopCountdown();
		}
	};


	formatTime = (timeString, showFullDateTime = false) => {
		if (!timeString) return '';

		try {
			// Handle different time formats
			let date;

			// If it's in format "2026-02-25 06:10:00 PM"
			if (typeof timeString === 'string' && timeString.includes(':')) {
				// Parse the datetime string
				const cleanTimeString = timeString.replace(/\s+/g, ' ').trim();
				date = new Date(cleanTimeString);

				// If parsing failed, try alternative formats
				if (isNaN(date.getTime())) {
					// Try to handle format like "2026-02-25 06:10:00 PM"
					const parts = cleanTimeString.split(' ');
					if (parts.length >= 2) {
						const datePart = parts[0];
						const timePart = parts[1] + ' ' + (parts[2] || '');
						date = new Date(datePart + ' ' + timePart);
					}
				}
			} else {
				// Try direct parsing
				date = new Date(timeString);
			}

			// If still invalid, return the original string
			if (isNaN(date.getTime())) {
				return timeString;
			}

			// Format to full date time or just time based on flag
			if (showFullDateTime) {
				return date.toLocaleString('en-US', {
					weekday: 'short',
					year: 'numeric',
					month: 'short',
					day: 'numeric',
					hour: 'numeric',
					minute: '2-digit',
					hour12: true
				});
			} else {
				// Format to 12-hour time with AM/PM
				return date.toLocaleTimeString('en-US', {
					hour: 'numeric',
					minute: '2-digit',
					hour12: true
				});
			}
		} catch (error) {
			console.error('Error formatting time:', error);
			return timeString;
		}
	}

	startCountdown = (plannedClosedAt) => {
		if (this.countdownInterval) {
			clearInterval(this.countdownInterval);
		}

		if (!plannedClosedAt) return;
		// console.log("currentStore====",this.props.currentStore)
		// Reset warning shown flag when starting a new countdown
		this.setState({ warningShown: false });

		this.countdownInterval = setInterval(() => {
			try {
				const now = new Date();
				let targetDate;

				// Parse the planned closed at time
				if (typeof plannedClosedAt === 'string' && plannedClosedAt.includes(':')) {
					const cleanTimeString = plannedClosedAt.replace(/\s+/g, ' ').trim();
					targetDate = new Date(cleanTimeString);

					if (isNaN(targetDate.getTime())) {
						const parts = cleanTimeString.split(' ');
						if (parts.length >= 2) {
							const datePart = parts[0];
							const timePart = parts[1] + ' ' + (parts[2] || '');
							targetDate = new Date(datePart + ' ' + timePart);
						}
					}
				} else {
					targetDate = new Date(plannedClosedAt);
				}

				if (isNaN(targetDate.getTime())) {
					this.setState({ remainingTime: null });
					return;
				}

				const difference = targetDate - now;

				if (difference > 0) {
					const hours = Math.floor(difference / (1000 * 60 * 60));
					const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
					const seconds = Math.floor((difference % (1000 * 60)) / 1000);

					let timeString = '';
					if (hours > 0) {
						timeString = `${hours}h ${minutes}m ${seconds}s`;
					} else if (minutes > 0) {
						timeString = `${minutes}m ${seconds}s`;
					} else {
						timeString = `${seconds}s`;
					}

					this.setState({ remainingTime: timeString });

					// Show warning modal when less than 10 minutes remaining and store can sell
					const { currentStore } = this.props;
					const canSell = currentStore?.can_sell;
					const canSellNow = canSell === true || canSell === 1 || canSell === '1';
					if (!this.state.warningShown && difference <= 10 * 60 * 1000 && canSellNow && this.checkEligibilityToShow('open_business_day')) {
						this.setState({ warningShown: true });
						this.showOverrideModal();
					}
				} else {
					this.setState({ remainingTime: 'Overdue' });
					const fallbackBusinessDayId = (() => {
						const fromState = this.state.businessDayInfo?.id;
						if (fromState != null) return String(fromState);
						try {
							const raw = localStorage.getItem('businessDayInfo');
							const parsed = raw ? JSON.parse(raw) : null;
							if (parsed && parsed.id != null) return String(parsed.id);
						} catch (e) {
						}
						return '';
					})();

					const payload = {
						businessDayAction: 'overdue',
						businessDayId: fallbackBusinessDayId,
						ts: Date.now()
					};
					channel.postMessage(payload);
					try {
						localStorage.setItem(BUSINESS_DAY_OVERDUE_STORAGE_KEY, JSON.stringify(payload));
					} catch (e) {
					}

					// Track overdue state without destructive page reload
					const incomingId = payload.businessDayId !== '' ? payload.businessDayId : `ts:${payload.ts}`;
					sessionStorage.setItem('lastOverdueReloadedBusinessDayId', incomingId);
					// Show warning modal when overdue only if current store can sell
					const { currentStore } = this.props;
					const canSell = currentStore?.can_sell;
					const canSellNow = canSell === true || canSell === 1 || canSell === '1';
					if (!this.state.warningShown && canSellNow && this.checkEligibilityToShow('open_business_day')) {
						this.setState({ warningShown: true });
						this.showOverrideModal();
					}
					if (this.countdownInterval) {
						clearInterval(this.countdownInterval);
						this.countdownInterval = null;
					}
					// console.log("MT---", this.state.remainingTime, "!==", "Overdue")
					// if(this.state.remainingTime !== undefined && this.state.remainingTime !== "Overdue"){
					// 	window.location.reload();
					// }
				}
			} catch (error) {
				console.error('Error in countdown:', error);

				if (this.countdownInterval) {
					clearInterval(this.countdownInterval);
					this.countdownInterval = null;
				}
			}
		}, 1000);
	}

	stopCountdown = () => {
		if (this.countdownInterval) {
			clearInterval(this.countdownInterval);
			this.countdownInterval = null;
		}
		this.setState({ remainingTime: null });
	}

	// Business Day Override Modal Methods
	showOverrideModal = (force = false) => {
		if (!force && this.props.skipBusinessDayOverrideWarningFlag) {
			return;
		}
		// Calculate remaining time to determine if cancel should be allowed
		const allowCancel = this.calculateOverrideAllowCancel();
		this.setState({
			// showOverrideModal: !Utility.isMainOrProcurementHubStore(this.props.currentStore),
			showOverrideModal: true,
			overrideAllowCancel: allowCancel
		});
	}

	handleSkipOverrideModal = () => {
		this.props.skipBusinessDayOverrideWarning(true);
		this.hideOverrideModal();
	}

	calculateOverrideAllowCancel = () => {
		if (!this.state.businessDayInfo || !this.state.businessDayInfo.planned_closed_at) {
			return false; // No business day info, don't allow cancel
		}

		try {
			const now = new Date();
			let targetDate = new Date(this.state.businessDayInfo.planned_closed_at);

			// If parsing failed, try alternative format
			if (isNaN(targetDate.getTime())) {
				const cleanTimeString = this.state.businessDayInfo.planned_closed_at.replace(/\s+/g, ' ').trim();
				targetDate = new Date(cleanTimeString);
			}

			if (!isNaN(targetDate.getTime())) {
				const difference = targetDate - now;
				const differenceInMinutes = difference / (1000 * 60);

				// Allow cancel if less than 10 minutes remaining but not overdue
				// Don't allow cancel if overdue (0 or negative)
				return differenceInMinutes > 0 && differenceInMinutes < 10;
			}
		} catch (error) {
			console.error('Error calculating override allow cancel:', error);
		}

		return false; // Default to not allowing cancel
	}

	hideOverrideModal = () => {
		this.setState({
			showOverrideModal: false,
			overrideFormData: {
				override_hours: '00',
				override_minutes: '00',
				override_reason: ''
			},
			overrideErrors: {
				override_reason: ''
			}
		});
	}

	handleOverrideInputChange = (field, value) => {
		// Validate hours and minutes
		if (field === 'override_hours' || field === 'override_minutes') {
			const numValue = parseInt(value) || 0;
			const maxValue = field === 'override_hours' ? 23 : 59;
			const validValue = Math.min(Math.max(0, numValue), maxValue);
			const formattedValue = validValue.toString().padStart(2, '0');

			this.setState({
				overrideFormData: {
					...this.state.overrideFormData,
					[field]: formattedValue
				}
			});
		} else {
			this.setState({
				overrideFormData: {
					...this.state.overrideFormData,
					[field]: value
				}
			});
		}
	}

	validateOverrideForm = () => {
		const { override_reason } = this.state.overrideFormData;
		const errors = {};

		if (!override_reason || override_reason.trim() === '') {
			errors.override_reason = 'Override reason is required';
		}

		this.setState({ overrideErrors: errors });
		return Object.keys(errors).length === 0;
	}

	handleOverrideSubmit = async () => {
		if (!this.validateOverrideForm()) {
			return;
		}

		const { override_hours, override_minutes, override_reason } = this.state.overrideFormData;
		const override_duration = `${override_hours}:${override_minutes}`;

		this.setState({ overrideLoading: true });

		try {
			const response = await UtilityController.businessDayOverride(
				this.state.businessDayInfo.slack,
				{
					override_duration,
					override_reason
				}
			);

			if (response.success) {
				Utility.toastNotifications('Business day extended successfully', "Success", "success");

				sessionStorage.removeItem('lastOverdueReloadedBusinessDayId');
				// Update business day info with new planned close time
				if (response.data && response.data.planned_closed_at) {
					this.setState({
						businessDayInfo: {
							...this.state.businessDayInfo,
							planned_closed_at: response.data.planned_closed_at
						}
					});

					// Update localStorage
					const updatedBusinessDayInfo = {
						...this.state.businessDayInfo,
						planned_closed_at: response.data.planned_closed_at
					};
					localStorage.setItem('businessDayInfo', JSON.stringify(updatedBusinessDayInfo));

					// Restart countdown with new time
					this.startCountdown(response.data.planned_closed_at);


					// Notify other components that business day was extended
					channel.postMessage({ businessDayAction: 'extended' });
				}

				this.hideOverrideModal();
			} else {
				Utility.toastNotifications(response.message || 'Failed to extend business day', "Error", "error");
			}
		} catch (error) {
			console.error('Error extending business day:', error);
			Utility.toastNotifications('An error occurred while extending business day', "Error", "error");
		} finally {
			this.setState({ overrideLoading: false });
		}
	}

	// Handle broadcast messages from other tabs
	handleBroadcastMessage = (event) => {
		const { data } = event;

		// Handle business day changes from other tabs
		if (data.businessDayAction) {
			switch (data.businessDayAction) {
				case 'opened':
					// Refresh business day status when another tab opens it
					this.checkCurrentBusinessDay();
					break;
				case 'closed':
					// Refresh business day status when another tab closes it
					this.checkCurrentBusinessDay();
					break;
				case 'extended':
					// Refresh business day status when another tab extends it
					this.checkCurrentBusinessDay();
					break;
				default:
					break;
			}
		}

		// Handle overdue business day state (cross-tab)
		if (data.businessDayAction === 'overdue') {
			const incomingId = data.businessDayId != null && String(data.businessDayId) !== ''
				? String(data.businessDayId)
				: (data.ts != null ? `ts:${String(data.ts)}` : '');
			if (incomingId !== '') {
				sessionStorage.setItem('lastOverdueReloadedBusinessDayId', incomingId);
			}
		}

		// Handle logout from other tabs
		if (data.allTabAction === 'logoutAllTab') {
			window.location.reload();
		}
	};

	handleStorageEvent = (event) => {
		if (!event || event.key !== BUSINESS_DAY_OVERDUE_STORAGE_KEY) return;
		if (!event.newValue) return;

		let payload;
		try {
			payload = JSON.parse(event.newValue);
		} catch (e) {
			return;
		}

		if (!payload || payload.businessDayAction !== 'overdue') return;

		const incomingId = payload.businessDayId != null && String(payload.businessDayId) !== ''
			? String(payload.businessDayId)
			: (payload.ts != null ? `ts:${String(payload.ts)}` : '');

		if (incomingId !== '') {
			sessionStorage.setItem('lastOverdueReloadedBusinessDayId', incomingId);
		}
	}

	crossPanelWindow = null;
	isLoggingOut = false;

	switchToPms = () => {
		const { token, accessToken, refreshToken, expiresIn } = this.props;
		const expiryInterval = expiresIn?.expiryInterval ?? expiresIn;
		const payload = { token, accessToken, refreshToken, expiresIn: expiryInterval };
		const lng = localStorage.getItem('i18nextLng') || 'en';
		const newWindow = window.open(`${process.env.PMS_APP_URL}#/${lng}/auto_login`, '_blank');
		this.crossPanelWindow = newWindow;

		// Wait for the target window to signal it's ready, then send the payload
		const handleReady = (event) => {
			if (event.source === newWindow && event.data?.type === 'AUTO_LOGIN_READY') {
				newWindow.postMessage({ type: 'AUTO_LOGIN_PAYLOAD', payload }, '*');
				window.removeEventListener('message', handleReady);
			}
		};
		window.addEventListener('message', handleReady);
	}

	handleCrossPanelMessage = (event) => {
		if (event.data?.type === 'CROSS_PANEL_LOGOUT') {
			if (event.data.token && event.data.token === this.props.token) {
				this.logout();
			}
		}
	}

	logout = () => {
		if (this.isLoggingOut) return;
		this.isLoggingOut = true;
		const { logOutApp, setToken, setUserCredentials, loaderStateTrue, loaderStateFalse } = this.props;
		const currentToken = this.props.token;
		loaderStateTrue();
		if (this.crossPanelWindow && !this.crossPanelWindow.closed) {
			this.crossPanelWindow.postMessage({ type: 'CROSS_PANEL_LOGOUT', token: currentToken }, '*');
		}
		if (window.opener && !window.opener.closed) {
			window.opener.postMessage({ type: 'CROSS_PANEL_LOGOUT', token: currentToken }, '*');
		}
		logOutApp(this.props.accessToken, this.props.token).then((logoutResponce) => {
			setTimeout(() => {
				this.setState({
					isLogout: true
				}, () => {
					// Preserve the language across the storage wipe - redirects
					// build URLs from i18nextLng and a null produces /null/login
					const lng = localStorage.getItem('i18nextLng') || 'en';
					localStorage.setItem("store_id", "")
					localStorage.setItem("selectedTabName", "")
					setToken("", "", "", "", [], [], '').then((res) => {
						setUserCredentials({});
					})
					localStorage.clear();
					localStorage.setItem('i18nextLng', lng);
					const obj = {
						isLogout: this.state.isLogout,
						allTabAction: "logoutAllTab"
					}
					channel.postMessage(obj);
				})
			}, 1000)
		}).catch((error) => {
			console.error('Logout error:', error);
			this.isLoggingOut = false;
			loaderStateFalse();
		})
	}

	handleResize = (e) => {
		this.setState({ windowWidth: window.innerWidth });
	};


	canSwitchStore = () => {
		const uDetails = this.props.userCredentials?.user_details || {};
		if (uDetails.is_super_admin === 1 || this.props.userCredentials?.is_super_admin === 1) {
			return true;
		}
		const role = this.props.userEntryType?.user_type || this.props.userEntryType?.role_name || uDetails.user_type || uDetails.role_name || this.props.userCredentials?.user_type || "";
		const allowedRoles = ["admin", "org_admin", "super_admin", "app_admin", "owner", "support admin", "support_admin"];
		if (Array.isArray(role)) {
			return role.some(r => allowedRoles.includes(String(r).toLowerCase().trim()));
		}
		return allowedRoles.includes(String(role).toLowerCase().trim());
	};

	componentDidUpdate = async (prevProps) => {
		const hadCreds = prevProps.userCredentials && Object.keys(prevProps.userCredentials).length > 0;
		const hasCreds = this.props.userCredentials && Object.keys(this.props.userCredentials).length > 0;
		const tokenChanged = prevProps.token !== this.props.token && this.props.token;
		const entryTypeChanged = prevProps.userEntryType?.id !== this.props.userEntryType?.id;

		if ((!hadCreds && hasCreds) || tokenChanged || entryTypeChanged || (!this.props.storesFetched && !this.state.loadingStores && hasCreds)) {
			if (this.canSwitchStore() || (this.props.stores && this.props.stores.length === 0)) {
				await this.fetchStores();
			}
		}
	};

	componentDidMount = async () => {
		document.body.addEventListener('mousedown', this.handleClickOutside.bind(this));

		// Listen for route changes to auto-refresh prerequisites checklist
		// when user returns from a setup page
		this.unlistenHistory = this.props.history.listen((location) => {
			const roleName = this.props.userCredentials?.user_details?.user_type;
			if (roleName === 'admin' || roleName === 'staff' || roleName === 'support admin' || this.canSwitchStore()) {
				setTimeout(() => this.fetchPrerequisitesChecklist(), 500);
			}
		});
		// let roleName = this.props.userCredentials?.user_details?.role_name || this.props.userCredentials?.user_details?.user_type
		let roleName = this.props.userCredentials?.user_details?.user_type;
		if (Object.keys(this.props.userCredentials).length > 0 && this.props.token !== "" && (this.canSwitchStore() || roleName == "waiter")) {
			await this.fetchStores();
		}

		await this.notificationListFn()
		// console.log("this.props.userCredentials?.user_details?.user_type===",this.props.userCredentials?.user_details?.user_type)
		// Fetch prerequisites checklist for admin/staff roles
		if (Object.keys(this.props.userCredentials).length > 0 && this.props.token !== "" && (this.canSwitchStore() || roleName == "waiter")) {
			// These are independent - run in parallel so the business day
			// button is not delayed behind the prerequisites checklist call
			this.fetchPrerequisitesChecklist();
			this.checkCurrentBusinessDay();
		} else if (Object.keys(Utility.getRoleObjectByEventKey('business_account')).length > 0 && this.hasPermission(this.props.userCredentials?.user_details?.user_type, 'business_account', 3, 'business_registers', ['CRUD', 'CUD', 'R'])) {
			await this.checkCurrentBusinessDay();
		}

		// Listen for store creation/update events
		this.storeCreatedListener = EventEmitter.addListener('storeCreated', this.refreshStores);
		this.storeUpdatedListener = EventEmitter.addListener('storeUpdated', this.refreshStores);
		this.storeOperatingHoursUpdatedListener = EventEmitter.addListener('storeOperatingHoursUpdated', this.checkCurrentBusinessDay);
		this.prerequisitesChangedListener = EventEmitter.addListener('prerequisitesChanged', this.fetchPrerequisitesChecklist);
		this.refreshNotificationsListener = EventEmitter.addListener('refreshNotifications', this.notificationListFn);

		setTimeout(() => {
			this.setState({ closeDayShowFlag: true })
		}, 5000)

		// Listen for business day changes across tabs
		channel.addEventListener('message', this.handleBroadcastMessage);
		window.addEventListener('storage', this.handleStorageEvent);
		window.addEventListener('message', this.handleCrossPanelMessage);
	}

	componentWillUnmount() {
		document.body.removeEventListener('mousedown', this.handleClickOutside.bind(this));
		window.removeEventListener('message', this.handleCrossPanelMessage);
		if (this.unlistenHistory) {
			this.unlistenHistory();
		}
		// Remove EventEmitter listeners using fbemitter's remove method
		if (this.storeCreatedListener) {
			this.storeCreatedListener.remove();
		}
		if (this.storeUpdatedListener) {
			this.storeUpdatedListener.remove();
		}
		if (this.storeOperatingHoursUpdatedListener) {
			this.storeOperatingHoursUpdatedListener.remove();
		}
		if (this.prerequisitesChangedListener) {
			this.prerequisitesChangedListener.remove();
		}
		if (this.refreshNotificationsListener) {
			this.refreshNotificationsListener.remove();
		}

		this.setState({ closeDayShowFlag: false })
		// Remove broadcast channel listener
		channel.removeEventListener('message', this.handleBroadcastMessage);
		window.removeEventListener('storage', this.handleStorageEvent);
	}

	handleClickOutside(event) {
		const concernedElement = document.querySelector(".popover_notificationParrentBox");
		const prerequisitesElement = document.querySelector(".popover_prerequisitesParrentBox");
		if ((concernedElement && concernedElement.contains(event.target)) ||
			(prerequisitesElement && prerequisitesElement.contains(event.target))) {
		} else {
			this.setState({
				showPopup: false,
				showPrerequisitesPopup: false,
				offset: 0,
				limit: 10
			})
		}
	}

	handleNotificationClick = (value) => {
		if (value.action && value.action !== "") {
			const lng = localStorage.getItem('i18nextLng') || 'en-US';
			this.setState({ showPopup: false, showPrerequisitesPopup: false });
			this.props.history.push(`/${lng}${value.action}`);
		}
	}

	//notification header ui
	notificationsUi = () => {
		const { notificationsData } = this.state;
		let notiArry = []
		if (notificationsData.length > 0) {
			notificationsData.map((value, idx) => {
				if (value.is_read) {
					notiArry.push(
						<div className={value.action && value.action !== "" ? "popover_notification_row notidivider isActionRow" : "popover_notification_row notidivider isreadRow"}
							key={idx}
							onClick={() => this.handleNotificationClick(value)}>
							<div className="noti_icon_box">
								<i className="fa fa-bell" aria-hidden="true"></i>
							</div>
							<div className="noti_user_box">
								{/* <h5>{value.subject}</h5> */}
								<h5>{Utility.getDateFormat(value.created_at)}</h5>
								<p>{value.notification_text}</p>
							</div>
							<div className='seenUnseenBox'>
								<OverlayTrigger placement="bottom" overlay={<Tooltip>Unseen</Tooltip>}>
									<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-check-circle unseen" viewBox="0 0 16 16">
										<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
										<path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
									</svg>
								</OverlayTrigger>
								<OverlayTrigger placement="bottom" overlay={<Tooltip>Seen</Tooltip>}>
									<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor" className="bi bi-eye seen" viewBox="0 0 16 16">
										<path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
										<path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
									</svg>
								</OverlayTrigger>
							</div>
						</div>
					)
				} else {
					notiArry.push(
						<div className={value.action && value.action !== "" ? "popover_notification_row notidivider notread isActionRow" : "popover_notification_row notidivider notread"}
							key={idx}
							onClick={() => {
								this.notificationsRead(value.id);
								this.handleNotificationClick(value);
							}}>
							<div className="noti_icon_box">
								<i className="fa fa-bell" aria-hidden="true"></i>
							</div>
							<div className="noti_user_box">
								{/* <h5>{value.subject}</h5> */}
								<h5>{Utility.getDateFormat(value.created_at)}</h5>
								<p>{value.notification_text}</p>
							</div>
							<div className='seenUnseenBox'>
								<OverlayTrigger placement="bottom" overlay={<Tooltip>Unseen</Tooltip>}>
									<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-check-circle unseen" viewBox="0 0 16 16">
										<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
										<path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
									</svg>
								</OverlayTrigger>
								<OverlayTrigger placement="bottom" overlay={<Tooltip>Seen</Tooltip>}>
									<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor" className="bi bi-eye seen" viewBox="0 0 16 16">
										<path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
										<path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
									</svg>
								</OverlayTrigger>
							</div>
						</div>
					)
				}
			})
		}

		return notiArry;
	}

	//load more notification
	loadMore = () => {
		const { limit, offset } = this.state;
		this.setState({
			offset: offset + limit
		}, () => {
			this.userNotifications().then((res) => {
				if (res.data.length > 0) {
					// Use total from API response instead of calculating
					this.setState({
						notificationsData: [...this.state.notificationsData, ...res.data],
						unreadNotificationCount: res.total
					}, () => {
						this.notificationsUi();
					})
				} else {
					this.setState({
						showLoadmore: false
					})
				}
			})
		})

	}

	//notification get api
	userNotifications = () => {
		let promise = new Promise((resolve, reject) => {
			const { loaderStateTrue, loaderStateFalse, userCredentials } = this.props;
			const { limit, offset } = this.state;
			let param = {}
			param = {
				"limit": limit,
				"offset": offset,
				"user_id": userCredentials.user_id,
				"store_id": localStorage.getItem("store_id"),
				"read": 0
			};

			let filters = {};
			filters['filters'] = JSON.stringify(param);

			loaderStateTrue()
			UtilityController.notifications(filters).then((res) => {
				if (res.success) {
					this.setState({
						showLoadmore: res.total > 5 ? true : false,
					})
					resolve(res)

				}

				loaderStateFalse()
			}).catch((error) => {
				console.error("************error*************", error)
				if (error) {
				}

				if (error.message == "Network Error") {

				}
				loaderStateFalse()
			});
		})
		return promise

	}

	// notificationsRead = (id) => {
	// 	const { loaderStateTrue, loaderStateFalse } = this.props;
	// 	let data = {}
	// 	data = {
	// 		"is_read": true,
	// 		"id": id,
	// 	};
	// 	loaderStateTrue();
	// 	UtilityController.notificationsUserId(data).then((response) => {
	// 		if (response.success) {
	// 			this.notificationListFn()
	// 		}
	// 		loaderStateFalse();
	// 	}).catch((error) => {
	// 		console.error("************error*************", error)
	// 		if (error) {
	// 		}
	// 		loaderStateFalse();
	// 		if (error.message == "Network Error") {
	// 		}
	// 	});
	// }
	notificationsRead = (id) => {
		const { loaderStateTrue, loaderStateFalse } = this.props;

		// Optimistic UI update: remove immediately
		this.setState(prevState => {
			const updatedList = prevState.notificationsData.filter(notif => notif.id !== id);
			const newUnreadCount = prevState.unreadNotificationCount - 1;

			return {
				notificationsData: updatedList,
				unreadNotificationCount: Math.max(0, newUnreadCount),
				// Optional: if list became short → you can decide to load more automatically
			};
		});

		// Call the PATCH / mark as read
		const data = {
			"is_read": true,
			"id": id,
		};

		loaderStateTrue();

		UtilityController.notificationsUserId(data)
			.then((response) => {
				if (!response.success) {
					// rollback on failure (rare, but good practice)
					console.warn("Mark as read failed → rolling back UI");
					this.setState(prev => ({
						notificationsData: [...prev.notificationsData, /* find & re-insert the item if you kept it */],
						unreadNotificationCount: prev.unreadNotificationCount + 1
					}));
				}
				loaderStateFalse();
			})
			.catch((error) => {
				console.error("Mark as read error:", error);
				// rollback
				this.setState(prev => ({
					unreadNotificationCount: prev.unreadNotificationCount + 1
				}));
				loaderStateFalse();
				// Optional: show toast "Failed to mark as read"
			});
	};

	// Mark every notification as read via the bulk API
	readAllNotifications = () => {
		const { loaderStateTrue, loaderStateFalse } = this.props;

		loaderStateTrue();

		UtilityController.markAllNotificationsAsRead({
			store_id: localStorage.getItem('store_id'),
		})
		.then(() => {
			Utility.toastNotifications('All notifications marked as read', 'Success', 'success');
			this.setState({ offset: 0 }, () => {
				this.notificationListFn();
			});
		})
		.catch((error) => {
			console.error("Read all notifications error:", error);
			Utility.toastNotifications('Failed to mark all notifications as read', 'Error', 'error');
			loaderStateFalse();
		});
	};

	openReadAllConfirmModal = () => {
		this.setState({ showReadAllConfirmModal: true });
	};

	cancelReadAllConfirmModal = () => {
		this.setState({ showReadAllConfirmModal: false });
	};

	confirmReadAllNotifications = () => {
		this.setState({ showReadAllConfirmModal: false }, () => {
			this.readAllNotifications();
		});
	};



	// Method to refresh stores (bypass cache)
	refreshStores = async () => {
		// Reset the storesFetched flag to force a fresh API call
		this.props.setStoresFetched(false);
		// Call fetchStores to get updated list
		await this.fetchStores();
	}

	getStoreBadgeStyle = () => {
		const store = this.props.currentStore;
		if (!store?.is_procurement_hub) {
			return { backgroundColor: '#28a745', color: '#fff' };
		}

		switch ((store.store_type || '').toUpperCase()) {
			case 'COST_CENTER':
				return { backgroundColor: '#D6A238', color: '#2B1B08' };
			case 'BRANCH':
				return { backgroundColor: '#C9891C', color: '#2B1B08' };
			case 'MAIN':
				return { backgroundColor: '#B87913', color: '#2B1B08' };
			default:
				return { backgroundColor: '#28a745', color: '#fff' };
		}

	}

	// Fetch prerequisites checklist
	fetchPrerequisitesChecklist = async () => {
		// app_admin should not trigger the prerequisites checklist
		if (this.props.userCredentials?.user_details?.user_type === 'app_admin') {
			return;
		}
		this.setState({ prerequisitesLoading: true });
		try {
			const response = await getOrderPrerequisitesChecklist();

			if (response.success && response.data) {
				let checklistData = response.data;

				// Bypass Supplier if store_type is COST_CENTER
				if (this.props.currentStore?.store_type === "COST_CENTER") {
					const { Supplier, ...filteredData } = checklistData;
					checklistData = filteredData;
				}

				const allPrerequisitesMet = Object.values(checklistData).every(value => value === true);

				this.setState({
					prerequisitesChecklist: checklistData,
					prerequisitesMissing: !allPrerequisitesMet,
					prerequisitesLoading: false
				});
			} else {
				console.error('Failed to fetch prerequisites:', response.message);
				this.setState({
					prerequisitesMissing: true,
					prerequisitesLoading: false
				});
			}
		} catch (error) {
			console.error('Error fetching prerequisites:', error);
			this.setState({
				prerequisitesMissing: true,
				prerequisitesLoading: false
			});
		}
	}

	// Show prerequisites popup
	showPrerequisitesPopup = () => {
		this.setState(prevState => ({
			showPrerequisitesPopup: !prevState.showPrerequisitesPopup,
			showPopup: false // Close notifications popup if open
		}));
	}

	// Navigate to prerequisite setup page
	handlePrerequisiteClick = (module) => {
		const route = PREREQUISITE_ROUTES[module];
		if (route) {
			const lng = localStorage.getItem('i18nextLng') || 'en';
			this.setState({ showPrerequisitesPopup: false });
			this.props.history.push(`/${lng}${route}`);
		}
	}

	handleOutsideClickMenuleft(e) {
		if (e.target.offsetParent) {
			if (e.target.localName != "aside") {
				if (e.target.className != "nav-link") {
					this.props.handleLeft(false);
				}
			}
		} else {

			if (e.target.parentNode.className != "nav-link") {
				if (e.target.parentNode.className.animVal != "float-right") {
				}
			}
			if (e.target.className.animVal == "fa-bars-menu") {
				this.props.handleLeft(false);
			}
			if (e.target.parentNode.className.animVal == "fa-bars-menu") {
				this.props.handleLeft(false);
			}
		}

	}
	handleBar = () => {
		this.props.handleLeft(!this.props.leftbar)
	}

	lanOnSelect = (lng) => {
		this.setState({
			langaugeConfirmModal: true,
			selectedLangauge: lng,

		})
	}


	confirmLangaugeChange = () => {
		const { selectedLangauge } = this.state;
		this.props.i18n.changeLanguage(selectedLangauge);
		let splitUrl = this.props.match.url.split('/');
		this.props.history.push(`/${selectedLangauge}/${splitUrl[2]}`);
		window.location.reload();
		this.setState({
			langaugeConfirmModal: false
		})

	}

	cancelLangaugeChange = () => {
		this.setState({
			langaugeConfirmModal: false,
		})
	}

	popover = () => (
		<Popover className="popover_notification_container">
			<Popover.Content>

				<div className="popover_notification_row">
					<h3 className="notititle">{this.props.t('notifications')}</h3>
				</div>

				<div>
					{this.notificationsUi()}
					{this.state.notificationsData.length > 0 && (
						<div className="d-flex justify-content-between mt-2">
							{this.state.showLoadmore ?
								<div onClick={this.loadMore} className="savebtn">{this.props.t('loadMore')}</div>
								: <div />}
							<div onClick={this.openReadAllConfirmModal} className="savebtn">Read All</div>
						</div>
					)}
				</div>


			</Popover.Content>
		</Popover>
	);


	showPopup = () => {
		this.setState({
			showPopup: true
		})
	}
	notificationListFn = () => {
		this.userNotifications().then((res) => {
			const unreadCount = res.data.filter(item => item.read === 0).length;
			this.setState({
				notificationsData: res.data,
				unreadNotificationCount: res.total, // Use total from API response
				offset: 0,
				limit: 10
			}, () => {
				this.notificationsUi();
			})
		})
	}


	changePassword = () => {
		this.setState({
			changePasswordFlag: true
		})
	}

	closeChangePassword = () => {
		let zoominzoomoutflag = ""
		this.setState({
			changePasswordFlag: false,
			zoominzoomoutflag: ""
		})
	}


	handleVersionChange = (event) => {
		let copyObject = Object.assign({}, this.props.userCredentials);
		copyObject["user_details"]["version"] = event.label.toLowerCase();
		copyObject["user_details"]["version_id"] = event.value;
		this.props.setUserCredentials(copyObject);
	}


	//alert notification
	handleCrossButtonClick = (id) => {
		this.setState((prevState) => ({
			notificationData: prevState.notificationData.filter((error) => error.id !== id)
		}));
	};

	showNotificationGetApiCall = () => {
		let filters = {};
		let globalQueryParamshash = {};
		globalQueryParamshash["status"] = true;
		filters['filters'] = globalQueryParamshash;
		this.props.loaderStateTrue();
		UtilityController.showNotification(filters).then((response) => {
			if (response.success) {
				if (response.data != null && response.data.length > 0) {
					let responseDataTempArray = [];
					let responseDataTempObj = {};
					response.data.map((e, index) => {
						responseDataTempObj = {};
						responseDataTempObj["message"] = e.message;
						responseDataTempObj["id"] = index;
						responseDataTempArray.push(responseDataTempObj)
					})
					this.setState({
						notificationData: responseDataTempArray
					})

				} else {
					this.setState({
						notificationData: []
					})
				}

			} else {
				Utility.toastNotifications("Something went wrong !", "Error", "error")
			}
			this.props.loaderStateFalse();
		}).catch((error) => {
			this.props.loaderStateFalse();
		});
	}

	zoominFunction = () => {
		let zoominzoomoutflag = "zoominzoomoutclassDialog"
		this.setState({
			zoominzoomoutflag: zoominzoomoutflag
		})
	}
	zoomoutFunction = () => {
		let zoominzoomoutflag = ""
		this.setState({
			zoominzoomoutflag: zoominzoomoutflag
		})
	}

	// Permission helper function
	hasPermission = (userType, roleKey, index, eventKey, allowedRules) => {
		if (userType === 'admin') return true;
		const role = Utility.getRoleObjectByEventKey(roleKey);
		if (!role || !role.subeventKey || role.subeventKey.length <= index) return false;
		const sub = role.subeventKey[index];
		// console.log("sub", sub)
		return sub.eventKey === eventKey && allowedRules.includes(sub.rules);
	};

	formatString = (inputString) => {
		const words = inputString.split('_');
		const formattedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));
		const formattedString = formattedWords.join('');
		return formattedString;
	}

	//profile modal open
	myProfileFN = () => {
		this.setState({
			myProfileModalFlag: true
		})
	}

	//close my profile modal
	closemyProfileModal = () => {
		let zoominzoomoutflag = ""
		this.setState({
			myProfileModalFlag: false,
			zoominzoomoutflag: zoominzoomoutflag
		})
	}

	detectChangesIndividualTab = (value = false) => {
		this.setState({
			tabchangeParent: value
		})
	}

	fetchStores = async (explicitEntryType = null) => {

		try {
			this.setState({ loadingStores: true });
			const stores = await StoreController.getStores();

			if (stores.success) {
				const activeEntryType = explicitEntryType || this.props.userEntryType;
				let currentStoreId = localStorage.getItem('store_id') || activeEntryType?.branch_id;

				// Branch-bound users are restricted to their assigned branch;
				// only roles allowed to switch stores may use a persisted selection
				if (activeEntryType?.branch_id != null && !this.canSwitchStore()) {
					currentStoreId = activeEntryType.branch_id;
				}

				// Find current store in main stores or child_stores
				let currentStore = stores.data?.find(store => Number(store.id) === Number(currentStoreId));

				// If not found in main stores, search in child_stores
				if (!currentStore && stores.data) {
					for (const parentStore of stores.data) {
						if (parentStore.child_stores && parentStore.child_stores.length > 0) {
							const foundInChild = parentStore.child_stores.find(childStore => Number(childStore.id) === Number(currentStoreId));
							if (foundInChild) {
								currentStore = foundInChild;
								break;
							}
						}
					}
				}

				// Fallback to first store if still not found
				if (!currentStore && stores.data && stores.data.length > 0) {
					currentStore = stores.data[0];
				}

				// Save current store to local state
				this.setState({
					currentStore: currentStore,
					loadingStores: false
				});

				// Dispatch to Redux store so other components can access it
				this.props.setCurrentStore(currentStore);
				this.props.setStores(stores.data || []);
				this.props.setStoresFetched(true); // Mark stores as fetched in Redux

				// Save to localStorage for persistence
				if (currentStore?.id) {
					localStorage.setItem('store_id', currentStore.id);
				}

				// Dispatch custom event to trigger store data refresh across listening pages
				const storeChangeEvent = new CustomEvent('dashboardStoreChange', {
					detail: { newStoreId: currentStore?.id, storeData: currentStore }
				});
				window.dispatchEvent(storeChangeEvent);
			} else {
				this.setState({ loadingStores: false });
			}
		} catch (error) {
			console.error('Error fetching stores:', error);
			this.setState({ loadingStores: false });
			this.props.setStoresFetched(false); // Reset fetched flag in case of error
		}
	};

	handleBusinessTypeChange = async (selectedBusinessType) => {
		try {
			// 1. Invalidate HTTP cache so new business type fetches fresh data
			invalidateApiCache();

			// 2. Clear old store selection from storage & reset fetched status
			localStorage.removeItem('store_id');
			this.props.setStoresFetched(false);

			// 3. Update active business type in Redux
			this.props.setUserEntryType(selectedBusinessType);

			// 4. Fetch updated user credentials for the newly selected business type
			try {
				const userRes = await getCurrentUser();
				if (userRes && userRes.success) {
					this.props.setUserCredentials(userRes.data);
				}
			} catch (err) {
				console.error("Failed to refresh user credentials on business type change:", err);
			}

			// 5. Fetch stores for the new organization
			await this.fetchStores(selectedBusinessType);

			// 6. Refresh prerequisites, business day & notifications for new store
			this.fetchPrerequisitesChecklist();
			this.checkCurrentBusinessDay();
			this.notificationListFn();

			// 7. Close mobile switch panel if open
			this.closeMobileSwitchPanel();

			// 8. Redirect cleanly to dashboard if not already on it
			const lng = localStorage.getItem('i18nextLng') || 'en';
			const dashboardPath = `/${lng}/dashboard`;
			if (this.props.location?.pathname !== dashboardPath && this.props.history) {
				this.props.history.push(dashboardPath);
			}
		} catch (error) {
			console.error('Error switching business type:', error);
		}
	};

	handleStoreChange = async (e) => {
		const selectedStore = e.value;
		try {
			// Update localStorage with the new store
			localStorage.setItem('store_id', selectedStore);

			// Update state with the selected store (search top-level stores and their child_stores)
			let selectedStoreData = this.props.stores.find(store => Number(store.id) === Number(selectedStore));
			if (!selectedStoreData) {
				for (const parentStore of this.props.stores) {
					if (parentStore.child_stores && parentStore.child_stores.length > 0) {
						const foundInChild = parentStore.child_stores.find(childStore => Number(childStore.id) === Number(selectedStore));
						if (foundInChild) {
							selectedStoreData = foundInChild;
							break;
						}
					}
				}
			}
			this.props.setCurrentStore(selectedStoreData);

			const currentPath = this.props.location.pathname;
			const dashboardPath = `/${localStorage.getItem('i18nextLng')}/dashboard`;
			const billingCounterPath = `/${localStorage.getItem('i18nextLng')}/dashboard/billing-counter`;

			// Dispatch custom event to trigger store data refresh across listening pages
			const storeChangeEvent = new CustomEvent('dashboardStoreChange', {
				detail: { newStoreId: selectedStore, storeData: selectedStoreData }
			});
			window.dispatchEvent(storeChangeEvent);

			// Refresh notifications and prerequisites for the new store
			await this.notificationListFn();

			// Refresh prerequisites checklist for admin/staff roles
			if (this.canSwitchStore()) {
				await this.fetchPrerequisitesChecklist();
				await this.checkCurrentBusinessDay();
			}

			// If on a page outside dashboard/billing-counter/accounts, navigate to dashboard
			if (
				currentPath !== dashboardPath && 
				currentPath !== billingCounterPath && 
				!currentPath.includes('/accounting-books') &&
				!currentPath.includes('/accounts')
			) {
				setTimeout(() => this.props.history.push(dashboardPath), 200);
			}

		} catch (error) {
			console.error('Error changing store:', error);
		}
	};
	//current user data get
	getCurrentUserData = () => {
		const { setUserCredentials } = this.props;
		getCurrentUser().then((response) => {
			if (response.success) {
				setUserCredentials(response.data);
				this.props.history.push('/');
			}
		}).catch((error) => {
			console.error("************error*************", error)
			loaderStateFalse();
		});
	}

	// PMS Sync handlers
	handleShowPmsSyncModal = () => {
		this.setState({ showPmsSyncModal: true });
	};

	handleClosePmsSyncModal = () => {
		this.setState({ showPmsSyncModal: false });
	};

	handleConfirmPmsSync = async () => {
		const { currentStore } = this.props;
		if (!currentStore?.id) {
			Utility.toastNotifications('Store ID not found', 'Error', 'error');
			return;
		}

		this.setState({ pmsSyncLoading: true, showPmsSyncModal: false });

		try {
			const response = await StoreController.syncCategoryAndProductWithPms();

			if (response.success) {
				Utility.toastNotifications(response.message || 'PMS sync initiated successfully', 'Success', 'success');
				window.dispatchEvent(new CustomEvent('pmsSyncCompleted'));
			} else {
				Utility.toastNotifications(response?.message || 'Failed to initiate PMS sync', 'Error', 'error');
			}
		} catch (error) {
			console.error('Error syncing with PMS:', error);
			Utility.toastNotifications('An error occurred while syncing with PMS', 'Error', 'error');
		} finally {
			this.setState({ pmsSyncLoading: false });
		}
	};

	render() {
		// const navigate = useNavigate();
		const { userCredentials } = this.props;
		const { subheaderShow, windowWidth, changePasswordModalOpen, formData, errorData } = this.state;
		let url = window.location.href;
		let currentRouteName = url.split("/").pop();
		let user_email = "";
		if (userCredentials && userCredentials.user_details && userCredentials.user_details.user_email != "") {
			user_email = userCredentials.user_details.user_email
		}
		if (user_email == "" && userCredentials && userCredentials.user_details && userCredentials.user_details.contact_number != "") {
			user_email = userCredentials.user_details.contact_number
		}
		let user_profile_image = "";
		if (userCredentials && userCredentials.user_details && userCredentials.user_details.hasOwnProperty('profile_img_url')) {
			let parseObject = userCredentials.user_details.profile_img_url ? JSON.parse(userCredentials.user_details.profile_img_url) : "";
			if (parseObject != "" && parseObject.hasOwnProperty('img_url') && parseObject.img_url != "") {
				user_profile_image = parseObject.img_url
			}
		}
		let user_first_name = userCredentials && userCredentials.user_details && userCredentials.user_details.first_name
		let user_last_name = userCredentials && userCredentials.user_details && userCredentials.user_details.last_name
		// let roleName = this.props.userCredentials?.user_details?.role_name || this.props.userCredentials?.user_details?.user_type
		let roleName = this.props.userCredentials?.user_details?.user_type
		let userId = this.props.userCredentials?.id
		// console.log("roleName",roleName)
		var rowData = {
			"user_type": roleName
		}
		let userType = {
			label: `${this.props.userEntryType && this.props.userEntryType.org_name.length > 0 ? `${this.props.userEntryType.org_name}` : ''}`,
			value: this.props.userEntryType.id,
			tooltipShow: `${this.props.userEntryType && this.props.userEntryType.org_name}`.length > 20 ? true : false
		};
		const currentUserType = this.props.userCredentials?.user_details?.user_type;
		// console.log("currentUserType==",currentUserType)

		//======= add action permission ====//
		// Check multiple permissions at once
		const openBusinessDayPermissions = Utility.hasMultipleActionPermissions(
			'open_business_day',
			'business_modal',
			['open_modal'],
			this.props.userCredentials?.user_details?.user_type || ['admin', 'app_admin']
		);
		// console.log("currentStore====", this.props.currentStore, "loggedin_branch_id", this.props.userEntryType?.branch_id)
		// Check if any actions are available for display in the table
		const hamburgerTableActions = openBusinessDayPermissions.open_modal;
		const storeBadgeText = this.props.currentStore?.name
			? `${this.props.currentStore?.name} - ${this.props.currentStore?.store_type == 'COST_CENTER' ? 'Department' : this.props.currentStore?.store_type?.toLowerCase() == 'branch' ? 'Branch' : 'Central'}`
			: '';
		
		const storeBadgeStyle = {
			...this.getStoreBadgeStyle(),
			padding: '6px 12px',
			fontSize: '13px',
			fontWeight: '600',
			borderRadius: '4px',
			display: 'inline-block',
			maxWidth: '20vw',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			verticalAlign: 'middle'
		};
		// Show tooltip whenever the text can overflow the badge width
		const storeBadge = storeBadgeText.length > 24 ? (
			<OverlayTrigger placement="bottom" overlay={<Tooltip id="store-badge-tooltip">{storeBadgeText}</Tooltip>}>
				<span className="badge" style={storeBadgeStyle}>{storeBadgeText}</span>
			</OverlayTrigger>
		) : (
			<span className="badge" style={storeBadgeStyle}>{storeBadgeText}</span>
		);

		// console.log("Object.keys(Utility.getRoleObjectByEventKey('business_account'))", this.hasPermission(currentUserType, 'business_account', 3, 'open_business_day', ['CRUD', 'CUD', 'R']))
		return (
			<div className={`${this.props.leftbar ? "sidebar-collapsed" : "sidebar-open"} header-top-inner-container`}>
				<header className={roleName != "app_admin" && this.state.notificationData.length > 0 && !(window.location.href.includes('sales/orders/add') || window.location.href.includes('sales/orders/edit') || window.location.href.includes('sales/digital-menu-orders')) ? "header_main header_main_index" : "header_main"} >
					{/* {currentRouteName == "dashboard" ?
						<div className='pageTitleBox'>{`${this.formatString(roleName)} Dashboard`.length >= 16 ? <OverlayTrigger overlay={<Tooltip>{`${this.formatString(roleName)} Dashboard`}</Tooltip>} placement='bottom'>
							<div className='chartCountBox'>
								{(`${this.formatString(roleName)} Dashboard`).substring(0, 13) + "..."}
							</div>
						</OverlayTrigger> : `${this.formatString(roleName)} Dashboard`}</div>
						: null}
					{currentRouteName == "agent_dashboard" ?
						<div className='pageTitleBox'>{`${this.formatString(roleName)} Dashboard`.length >= 16 ? <OverlayTrigger overlay={<Tooltip>{`${this.formatString(roleName)} Dashboard`}</Tooltip>} placement='bottom'>
							<div className='chartCountBox'>
								{(`${this.formatString(roleName)} Dashboard`).substring(0, 13) + "..."}
							</div>
						</OverlayTrigger> : `${this.formatString(roleName)} Dashboard`}</div>
						: null} */}
					{/* go Back Button */}
					{(window.location.href.includes('sales/orders/add') || window.location.href.includes('sales/orders/edit') || window.location.href.includes('sales/digital-menu-orders')) && (
						<button
							onClick={() => {
								if (window.history.length > 1) {
									// window.history.back();
									window.location.replace(`/#/${localStorage.getItem("i18nextLng") || "en"}/sales/orders`);
								} else {
									window.location.replace(`/#/${localStorage.getItem("i18nextLng") || "en"}/sales/orders`);
								}
							}}
							className="text-primary"
							style={{ background: 'none', border: 'none', color: '#fff' }}
						>
							<FontAwesomeIcon icon={faHome} className="my-auto" size="xl" />
						</button>
					)}

					{/* Business Day Button - Left Side */}
					{/* {(['admin'].includes(currentUserType) || (Object.keys(Utility.getRoleObjectByEventKey('business_account')).length > 0 && this.hasPermission(currentUserType, 'business_account', 4, 'open_business_day', ['CRUD', 'CUD', 'R']))) && (this.props.currentStore?.can_sell === 1 || this.props.currentStore?.can_sell === true) && ( */}

					{(
						['admin'].includes(currentUserType) ||
						(
							Object.keys(
								Utility.getRoleObjectByEventKey('business_account')
							).length > 0 &&
							this.hasPermission(
								currentUserType,
								'business_account',
								4,
								'open_business_day',
								['CRUD', 'CUD']
							)
						)
					) &&
					!Utility.isSubscriptionExpired(userCredentials) &&
					this.checkEligibilityToShow('open_business_day') && (
						<div
							className="business-day-container d-inline-flex align-items-center"
							style={{ marginLeft: '15px', verticalAlign: 'middle' }}
						>
							{/* !Utility.isMainOrProcurementHubStore(this.props.currentStore) */}
							{this.state.businessDayOpen && Utility.isChkBusinessDay(this.props.currentStore) ? (
								<div className="business-day-open d-inline-flex align-items-center">
									{/* Desktop view - unchanged */}
									<div className="d-none d-md-inline-flex align-items-center 1">
										<div className="me-2">
											{this.state.businessDayInfo && (
												<div
													className="business-day-details"
													style={{ fontSize: '11px', color: '#666', lineHeight: '1.2' }}
												>
													<div style={{ marginBottom: '2px' }}>
														<OverlayTrigger
															placement="right"
															overlay={
																<Tooltip>
																	<div><strong>Business Hours</strong></div>
																	<div>Open: {Utility.getDateFormat(this.state.businessDayInfo.opened_at)}</div>
																	{this.state.businessDayInfo.planned_closed_at && (
																		<div>Close: {Utility.getDateFormat(this.state.businessDayInfo.planned_closed_at)}</div>
																	)}
																</Tooltip>
															}
														>
															<i
																className="fa fa-info-circle me-1"
																style={{ cursor: 'pointer', color: this.props.currentStore?.is_procurement_hub ? '#A8C8F0' : '#007bff' }}
															></i>
														</OverlayTrigger>
														Open: {this.formatTime(this.state.businessDayInfo.opened_at)}
													</div>

													{this.state.remainingTime && (
														<div
															style={{
																fontWeight: 'bold',
																color:
																	this.props.currentStore?.store_type === 'COST_CENTER'
																		? '#D6C2A5'
																		: this.state.remainingTime === 'Overdue'
																			? (this.props.currentStore?.is_procurement_hub ? '#E8C8D0' : '#dc3545')
																			: (this.props.currentStore?.is_procurement_hub ? '#D4C8E0' : '#28a745')
															}}
														>
															{/* !Utility.isSubscriptionExpired(userCredentials) */}
															<i className="fa fa-clock me-1"></i>
															Left: {this.state.remainingTime}
															{(this.state.remainingTime === 'Overdue' || this.state.warningShown) &&
																this.checkEligibilityToShow('open_business_day') &&
																(
																	['admin'].includes(currentUserType) ||
																	(
																		Object.keys(
																			Utility.getRoleObjectByEventKey('business_account')
																		).length > 0 &&
																		this.hasPermission(
																			currentUserType,
																			'business_account',
																			4,
																			'open_business_day',
																			['CRUD', 'CUD']
																		)
																	)
																)
																//  && Utility.isChkBusinessDay(this.props.currentStore)
																&& (
																	<button
																		onClick={() => this.showOverrideModal(true)}
																		className="btn btn-sm btn-outline-primary ms-2"
																		style={{ padding: '2px 6px', fontSize: '8px' }}
																		title="Extend Business Day"
																	>
																		<FontAwesomeIcon icon={faPlus} />
																	</button>
																)}
														</div>
													)}
												</div>
											)}
										</div>
										{/* !Utility.isMainOrProcurementHubStore(this.props.currentStore) */}
										{(['admin'].includes(currentUserType) &&
											this.checkEligibilityToShow('open_business_day') ||
											(
												Object.keys(
													Utility.getRoleObjectByEventKey('business_account')
												).length > 0 &&
												this.hasPermission(
													currentUserType,
													'business_account',
													4,
													'open_business_day',
													['CRUD', 'CUD']
												)
											)
										) &&
											!Utility.isSubscriptionExpired(userCredentials) &&
											this.checkEligibilityToShow('open_business_day')
											// Utility.isChkBusinessDay(this.props.currentStore) 
											&& (
												<button
													onClick={this.closeBusinessDay}
													disabled={this.state.businessDayLoading}
													className="btn btn-sm btn-outline-danger close-day-btn"
													title="Close Business Day"
												>
													{this.state.businessDayLoading ? (
														<div className="spinner-border spinner-border-sm" role="status">
															<span className="visually-hidden">Loading...</span>
														</div>
													) : (
														<>
															<i className="fa fa-door-closed me-1"></i>
															Close Day
														</>
													)}
												</button>
											)}

										<div>
											<div
												style={{
													fontSize: '11px',
													color:
														this.props.currentStore?.store_type === 'COST_CENTER'
															? '#D6C2A5'
															: this.state.remainingTime === 'Overdue'
																? (this.props.currentStore?.is_procurement_hub ? '#E8C8D0' : '#dc3545')
																: (this.props.currentStore?.is_procurement_hub ? '#D4C8E0' : '#28a745'),
													lineHeight: '1.2',
													marginLeft: '10px'
												}}
											>
												Business Date: {this.state.business_date || "--"}
											</div>
										</div>
									</div>

									{/* Mobile view - button + info icon only */}
									{/* !Utility.isMainOrProcurementHubStore(this.props.currentStore) */}
									<div className="d-inline-flex d-md-none align-items-center">
										{(
											['admin'].includes(currentUserType) ||
											(
												Object.keys(
													Utility.getRoleObjectByEventKey('business_account')
												).length > 0 &&
												this.hasPermission(
													currentUserType,
													'business_account',
													4,
													'open_business_day',
													['CRUD', 'CUD']
												)
											)
										) &&
											!Utility.isSubscriptionExpired(userCredentials) &&
											this.checkEligibilityToShow('open_business_day')
											//  && Utility.isChkBusinessDay(this.props.currentStore) 
											&& (
												<button
													onClick={this.closeBusinessDay}
													disabled={this.state.businessDayLoading}
													className="btn btn-sm btn-outline-danger close-day-btn"
													title="Close Business Day"
												>
													{this.state.businessDayLoading ? (
														<div className="spinner-border spinner-border-sm" role="status">
															<span className="visually-hidden">Loading...</span>
														</div>
													) : (
														<>
															<i className="fa fa-door-closed me-1"></i>
															Close Day
														</>
													)}
												</button>
											)}

										<OverlayTrigger
											placement="bottom"
											overlay={
												<Tooltip id="mobile-business-day-tooltip">
													<div style={{ textAlign: 'left', minWidth: '100%' }}>
														<div style={{ marginBottom: '6px' }}>
															<strong>Business Hours</strong>
														</div>

														{this.state.businessDayInfo && (
															<>
																<div style={{ marginBottom: '4px' }}>
																	Open: {this.formatTime(this.state.businessDayInfo.opened_at)}
																</div>

																<div style={{ marginBottom: '4px' }}>
																	Open Date: {Utility.getDateFormat(this.state.businessDayInfo.opened_at)}
																</div>

																{this.state.businessDayInfo.planned_closed_at && (
																	<div style={{ marginBottom: '4px' }}>
																		Close: {Utility.getDateFormat(this.state.businessDayInfo.planned_closed_at)}
																	</div>
																)}
															</>
														)}

														{this.state.remainingTime && (
															<div style={{ marginBottom: '4px' }}>
																Left: {this.state.remainingTime}
															</div>
														)}

														<div>
															Business Date: {this.state.business_date || "--"}
														</div>
													</div>
												</Tooltip>
											}
										>
											<i
												className="fa fa-info-circle ms-2"
												style={{ cursor: 'pointer', color: '#007bff', fontSize: '16px' }}
											></i>
										</OverlayTrigger>
									</div>
								</div>
							) : (
								this.state.closeDayShowFlag && (
									<>
										{/* Desktop view - unchanged */}
										{/* !Utility.isMainOrProcurementHubStore(this.props.currentStore */}
										<div className="d-none d-md-inline-flex align-items-center 2">
											{
												(
													['admin'].includes(currentUserType) ||
													(
														Object.keys(
															Utility.getRoleObjectByEventKey('business_account')
														).length > 0 &&
														this.hasPermission(
															currentUserType,
															'business_account',
															4,
															'open_business_day',
															['CRUD', 'CUD']
														)
													)
												) &&
												!Utility.isSubscriptionExpired(userCredentials) &&
												this.checkEligibilityToShow('open_business_day')
												// Utility.isChkBusinessDay(this.props.currentStore) 
												&& (
													<button
														onClick={this.openBusinessDay}
														disabled={this.state.businessDayLoading}
														className="btn btn-sm btn-outline-success"
														title="Open Business Day"
													>
														{this.state.businessDayLoading ? (
															<div className="spinner-border spinner-border-sm" role="status">
																<span className="visually-hidden">Loading...</span>
															</div>
														) : (
															<>
																<i className="fa fa-door-open me-1"></i>
																Open Business Day
															</>
														)}
													</button>
												)}
										</div>

										{/* Mobile view - button + info icon only */}
										{/* !Utility.isMainOrProcurementHubStore(this.props.currentStore) */}
										<div className="d-inline-flex d-md-none align-items-center">
											{
												(
													['admin'].includes(currentUserType) ||
													(
														Object.keys(
															Utility.getRoleObjectByEventKey('business_account')
														).length > 0 &&
														this.hasPermission(
															currentUserType,
															'business_account',
															4,
															'open_business_day',
															['CRUD', 'CUD']
														)
													)
												) &&
												!Utility.isSubscriptionExpired(userCredentials) &&
												openBusinessDayPermissions.open_modal &&
												this.checkEligibilityToShow('open_business_day')
												// Utility.isChkBusinessDay(this.props.currentStore) 
												&& (
													<button
														onClick={this.openBusinessDay}
														disabled={this.state.businessDayLoading}
														className="btn btn-sm btn-outline-success"
														title="Open Business Day"
													>
														{this.state.businessDayLoading ? (
															<div className="spinner-border spinner-border-sm" role="status">
																<span className="visually-hidden">Loading...</span>
															</div>
														) : (
															<>
																<i className="fa fa-door-open me-1"></i>
																Open Business Day
															</>
														)}
													</button>
												)}

											<OverlayTrigger
												trigger="click"
												rootClose
												placement="bottom"
												overlay={
													<Tooltip id="mobile-business-day-tooltip-closed">
														<div style={{ textAlign: 'left', minWidth: '100%' }}>
															<div style={{ marginBottom: '6px' }}>
																<strong>Business Info</strong>
															</div>
															<div>
																Business Date: {this.state.business_date || "--"}
															</div>
														</div>
													</Tooltip>
												}
											>
												<i
													className="fa fa-info-circle ms-2"
													style={{ cursor: 'pointer', color: '#007bff', fontSize: '16px' }}
												></i>
											</OverlayTrigger>
										</div>
									</>
								)
							)}
						</div>
					)}

					<div className="header_right user_icon_innner" >
						<ul className="nav_ul">
							{/* Store Name Display for PMS Connected Stores or non-switchable users */}
							{this.props.currentStore?.is_pms_connected || !this.canSwitchStore() ? (
								<li className="processbar" style={{ marginRight: '15px' }}>
									{storeBadge}
								</li>
							) : ""}

							<OverlayTrigger
								rootClose={true}
								trigger="click"
								placement="bottom"
								show={this.state.showPopup}
								overlay={
									<Popover className="popover_notification_container">
										<Popover.Body>
											<div className="popover_notification_row">
												<h3 className="notititle">{this.props.t('notifications')}</h3>
											</div>
											<div className="popover_notificationParrentBox" ref={this.codeOutsideClickRef}>
												<div className='notificationsUiBox'>{this.notificationsUi()}</div>
												{this.state.notificationsData.length > 0 && (
													<div className="d-flex justify-content-between mt-2">
														{this.state.showLoadmore ?
															<div onClick={this.loadMore} className="savebtn">{this.props.t('loadMore')}</div>
															: <div />}
														<div onClick={this.openReadAllConfirmModal} className="savebtn">Read All</div>
													</div>
												)}
											</div>
										</Popover.Body>
									</Popover>
								}

							>
								<li className={this.state.notificationsData.length > 0 ? "notificationbar animationShow" : "processbar"} onClick={this.showPopup}><i className="fa fa-bell" aria-hidden="true"></i>
									{this.state.unreadNotificationCount > 0 ?
										<sup>{this.state.unreadNotificationCount > 99 ? '99+' : this.state.unreadNotificationCount}</sup>
										: <sup>0</sup>}
								</li>

							</OverlayTrigger>

							{/* Prerequisites Checklist Notification - Only for admin/staff */}
							{(roleName == "admin" || roleName == "staff") && (
								<OverlayTrigger
									rootClose={true}
									trigger="click"
									placement="bottom"
									show={this.state.showPrerequisitesPopup}
									overlay={
										<Popover className="popover_notification_container">
											<Popover.Body>
												<div className="popover_notification_row">
													<h3 className="notititle">Prerequisites Checklist</h3>
												</div>
												<div className="popover_prerequisitesParrentBox">
													{this.state.prerequisitesLoading ? (
														<div className="text-center p-3">
															<div className="spinner-border text-primary" role="status">
																<span className="visually-hidden">Loading...</span>
															</div>
															<p className="mt-2">Loading prerequisites...</p>
														</div>
													) : (
														<div className="prerequisites-list">
															{Object.keys(this.state.prerequisitesChecklist).length > 0 ? (
																Object.entries(this.state.prerequisitesChecklist).map(([module, isAvailable]) => {
																	const hasRoute = !isAvailable && PREREQUISITE_ROUTES[module];
																	return (
																		<div
																			key={module}
																			className={`popover_notification_row notidivider ${hasRoute ? 'prerequisite-item-clickable' : ''}`}
																			onClick={hasRoute ? () => this.handlePrerequisiteClick(module) : undefined}
																			style={hasRoute ? { cursor: 'pointer' } : {}}
																		>
																			<div className="noti_icon_box">
																				<FontAwesomeIcon
																					icon={isAvailable ? faCheckCircle : faTimesCircle}
																					className={isAvailable ? "text-success" : "text-danger"}
																				/>
																			</div>
																			<div className="noti_user_box">
																				<p>{module}</p>
																				<small className={isAvailable ? "text-success" : "text-danger"}>
																					{isAvailable ? "Completed" : "Pending"}
																				</small>
																			</div>
																		</div>
																	);
																})
															) : (
																<div className="text-center p-3">
																	<p>No checklist data available</p>
																</div>
															)}
														</div>
													)}
												</div>
											</Popover.Body>
										</Popover>
									}
								>
									<li
										className={this.state.prerequisitesMissing ? "notificationbar animationShow" : "processbar"}
										onClick={this.showPrerequisitesPopup}
										style={{ marginLeft: '5px', cursor: 'pointer' }}
										title={this.state.prerequisitesMissing
											? "Prerequisites Missing - Click to view details"
											: "All Prerequisites Met"
										}
									>
										<FontAwesomeIcon
											icon={this.state.prerequisitesMissing ? faTimesCircle : faCheckCircle}
											style={{ fontSize: "25px" }}
											className={this.state.prerequisitesMissing ? "text-warning" : "text-success"}
										/>
										{this.state.prerequisitesMissing && <sup>!</sup>}
									</li>
								</OverlayTrigger>
							)}

							{/* Sync With PMS Button - Only show when store is PMS connected */}
							{this.props.currentStore?.is_pms_connected === 1 && (
								<li
									className="processbar full-sync-action"
									onClick={this.handleShowPmsSyncModal}
									title="Sync Category & Product With PMS"
								>
									<FontAwesomeIcon
										icon={faSync}
										className={`${this.state.pmsSyncLoading ? "fa-spin" : ""} full-sync-icon`}
									/>
									<span className="full-sync-label">Full Sync</span>
								</li>)}
							{/* ********** For Mobile Start ************ */}
							{this.canSwitchStore() && this.props.stores?.length > 0 ? (<li className="mobileSwitchToggle" onClick={this.toggleMobileSwitchPanel}>
								<OverlayTrigger placement="bottom" overlay={<Tooltip>Switch</Tooltip>}>
									<i className="fa fa-retweet" aria-hidden="true"></i>
								</OverlayTrigger>
							</li>) : null}

							<div className={`mobileSwitchPanel ${this.state.showMobileSwitchPanel ? "open" : ""}`}>
								<div className="mobileSwitchPanelHeader">
									<h4>Switch</h4>
									<button className="mobileSwitchClose" onClick={this.closeMobileSwitchPanel}>
										✕
									</button>
								</div>

								<div className="mobileSwitchPanelBody">
									{/* Business Type (same code you already have) */}
									{this.props.hasOwnProperty("userGroup") && this.props.userGroup && this.props.userGroup.length > 1 ? (
										<div className="switchOrganizationBoxContainer mobileOnlySwitchBox">
											<label>Switch Business Type :</label>
											<div className="dropdownBoxContainer versiondropBox dropdownCustomizeContainer">
												<AutosuggestComponent
													handleOnChange={this.handleBusinessTypeChange}
													options={this.props.userGroup.map((role, idx) => ({
														...role,
														label: `${this.props.userGroup?.[idx].org_name}`,
														value: this.props.userGroup?.[idx].id,
														tooltipShow: `${this.props.userGroup?.[idx].org_name}`.length > 20
													}))}
													selectedValue={userType}
													isMulti={false}
													placeholder="Choose role..."
													isDisabled={false}
													closeButton={false}
													menuHeader="Choose role"
													isSearchable={true}
												/>
											</div>
										</div>
									) : null}

									{/* Store (same code you already have) */}
									{this.canSwitchStore() && this.props.stores?.length > 0 ? (
										<div className="switchOrganizationBoxContainer mobileOnlySwitchBox">
											<label>Switch Store :</label>
											<div className="dropdownBoxContainer versiondropBox dropdownCustomizeContainer">
												<StoreSwitcherSelect
													handleOnChange={(e) => {
														this.handleStoreChange(e);
														this.closeMobileSwitchPanel(); // optional
													}}
													stores={this.props.stores}
													currentStore={this.props.currentStore}
													isMulti={false}
													placeholder="Choose store..."
													isDisabled={false}
													closeButton={false}
													menuHeader="Choose store"
													isSearchable={true}
												/>
											</div>
										</div>
									) : null}

								</div>
							</div>

							{/* Optional backdrop */}
							{this.state.showMobileSwitchPanel && (
								<div className="mobileSwitchBackdrop" onClick={this.closeMobileSwitchPanel}></div>
							)}
							{/* ********** For Mobile End ************ */}

							{this.props.hasOwnProperty("userGroup") && this.props.userGroup && this.props.userGroup.length > 1 ?
								<div className="switchOrganizationBoxContainer desktopOnlySwitch">
									<label>Switch Business Type : </label>
									<div className="dropdownBoxContainer versiondropBox dropdownCustomizeContainer">
										<AutosuggestComponent
											handleOnChange={this.handleBusinessTypeChange}
											options={this.props.userGroup.map((role, idx) => ({
												...role,
												label: `${this.props.userGroup?.[idx].org_name}`,
												value: this.props.userGroup?.[idx].id,
												tooltipShow: `${this.props.userGroup?.[idx].org_name}`.length > 20 ? true : false
											}))}
											selectedValue={userType}
											name=''
											isMulti={false}
											placeholder="Choose role..."
											isDisabled={false}
											closeButton={false}
											menuHeader="Choose role"
											isSearchable={true}
										/>
									</div>
								</div>
								: null}
							{this.canSwitchStore() && this.props.stores?.length > 0 ?
								<div className="switchOrganizationBoxContainer desktopOnlySwitch">
									<label>Switch Store : </label>
									<div className="dropdownBoxContainer versiondropBox dropdownCustomizeContainer">
										<StoreSwitcherSelect
											handleOnChange={this.handleStoreChange}
											stores={this.props.stores}
											currentStore={this.props.currentStore}
											name=''
											isMulti={false}
											placeholder="Choose store..."
											isDisabled={false}
											closeButton={false}
											menuHeader="Choose store"
											isSearchable={true}
										/>
									</div>
								</div>
								: null}
							{this.props.crossPanelAccess &&
								<li className='switch-button-box'>
									<button className="switchPanelBtn" onClick={this.switchToPms} title="Switch to PMS">
										Switch to PMS
									</button>
								</li>
							}
							{user_profile_image != "" ?
								<li>
									<OverlayTrigger placement="bottom" overlay={<Tooltip>{`${user_first_name} ${user_last_name}`}</Tooltip>}>
										<img className="user_icon" src={user_profile_image} />
									</OverlayTrigger>
								</li>
								:
								<li>
									<OverlayTrigger placement="bottom" overlay={<Tooltip>{`${user_first_name} ${user_last_name}`}</Tooltip>}>
										<div className="header_user_name_box">
											{user_first_name && user_first_name.charAt(0)}{user_last_name && user_last_name.charAt(0)}
										</div>
									</OverlayTrigger>
								</li>
							}
							<OverlayTrigger
								rootClose={true}
								trigger="click"
								placement="bottom"
								overlay={
									<Popover className="popover_action_inner_container">
										<Popover.Body>
											<div className="popover_action_row">
												<button className="mailtext" onClick={this.myProfileFN}>{this.props.t('My Profile')}</button>
												{roleName != "app_admin" &&
													<button className="changePasswordtext" onClick={this.changePassword}>{this.props.t('ChangePasswordButton')}</button>}

												<button className="logouttext" onClick={this.logout}>{this.props.t('logoff')}</button>
											</div>
										</Popover.Body>
									</Popover>
								}
							>
								<li className="logoutbox"><i className="fa fa-sort-desc" aria-hidden="true"></i></li>
							</OverlayTrigger>
						</ul>
					</div>

					<ModalGlobal
						show={this.state.langaugeConfirmModal}
						onHide={this.cancelLangaugeChange}
						className="modalcustomizeDialog confirmationalertmodalDialog"
						bodyClassName="cancelConfirmationbody"
						headerclassName="close_btn_icon"
						title={this.props.t('languagechange')}
						footer={false}
						body={
							<ConfirmationAlert
								BodyFirstContent={this.props.t('areYouSureYouWantToReload')}
								confirmationButtonContent={this.props.t('confirm')}
								deleteConfirmButton={this.confirmLangaugeChange}
								cancelButtonContent={this.props.t('cancel')}
								deleteCancleButton={this.cancelLangaugeChange}
							/>
						}
					/>

					<ModalGlobal
						show={this.state.changePasswordFlag}
						onHide={this.closeChangePassword}
						className={`${this.state.zoominzoomoutflag + ' ' + "modalcustomizeDialog mondimension changePasswordModal"}`}
						bodyClassName="cancelConfirmationbody"
						headerclassName="close_btn_icon"
						title={this.props.t('ChangePasswordButton')}
						footer={false}
						closeButton={true}
						body={
							<ChangePasswordContent
								closeChangePassword={this.closeChangePassword}
							/>
						}
					/>
					<ModalGlobal
						show={this.state.myProfileModalFlag}
						onHide={this.closemyProfileModal}
						className={`${this.state.zoominzoomoutflag + ' ' + "modalcustomizeDialog mondimension myProfileModalDialog"}`}
						bodyClassName="profileDetailsModalbody"
						headerclassName="close_btn_icon"
						saveButtonLabel="Submit"
						saveButtonClassName="btn btn-primary savebtn modBtnSave"
						title={this.props.t('My Profile')}
						footer={false}
						closeButton={true}
						zoominButton={this.state.zoominzoomoutflag != "" ? false : true}
						zoomoutButton={this.state.zoominzoomoutflag != "" ? true : false}
						zoomin={this.zoominFunction}
						zoomout={this.zoomoutFunction}
						cancelButtonClassName="modBtnSave cancelbtn"
						footerClassName="text-center topspaceUserProfile"
						body={

							<UserProfile
								profilecontentdispaly="profilecontentdispaly"
								userProfileId={userId}
								detectChangesIndividualTab={this.detectChangesIndividualTab}
								selectedRowsData={rowData}
								profileView={true}
							/>
						}
					/>

					{/* Business Day Override Modal */}
					{this.state.showOverrideModal && (
						<ModalGlobal
							show={this.state.showOverrideModal}
							// onHide={this.state.overrideAllowCancel ? this.hideOverrideModal : undefined}
							onHide={this.hideOverrideModal}
							className={`${this.state.zoominzoomoutflag + ' ' + "modalcustomizeDialog mondimension changePasswordModal"}`}
							bodyClassName="cancelConfirmationbody"
							headerclassName="close_btn_icon"
							title={
								<>
									<FontAwesomeIcon icon={faExclamationTriangle} className="me-2 text-warning" />
									Business Day Time Warning
								</>
							}
							footer={false}
							// closeButton={this.state.overrideAllowCancel}
							closeButton={false}
							cancelButtonClassName="modBtnSave cancelbtn"
							body={
								<div>
									<Alert variant="warning" className="mb-3">
										<FontAwesomeIcon icon={faClock} className="me-2" />
										<strong>Attention:</strong> The business day is about to end or has already ended!
									</Alert>

									<p className="mb-3">
										If you want to extend the business time, please specify the override duration and reason below.
										Otherwise, you should close the business day.
									</p>

									<Form>
										<Form.Group className="mb-3">
											<Form.Label>Override Duration</Form.Label>
											<div className="d-flex gap-2">
												<Form.Control
													type="number"
													min="0"
													max="23"
													value={this.state.overrideFormData.override_hours}
													onChange={(e) => this.handleOverrideInputChange('override_hours', e.target.value)}
													placeholder="HH"
													style={{ maxWidth: '80px' }}
												/>
												<span className="align-self-center">:</span>
												<Form.Control
													type="number"
													min="0"
													max="59"
													value={this.state.overrideFormData.override_minutes}
													onChange={(e) => this.handleOverrideInputChange('override_minutes', e.target.value)}
													placeholder="MM"
													style={{ maxWidth: '80px' }}
												/>
												<span className="align-self-center text-muted">(HH:MM)</span>
											</div>
										</Form.Group>

										<Form.Group className="mb-3">
											<Form.Label>Override Reason *</Form.Label>
											<Form.Control
												as="textarea"
												rows={3}
												value={this.state.overrideFormData.override_reason}
												onChange={(e) => this.handleOverrideInputChange('override_reason', e.target.value)}
												placeholder="Please provide a reason for extending the business day..."
												isInvalid={!!this.state.overrideErrors.override_reason}
											/>
											<Form.Control.Feedback type="invalid">
												{this.state.overrideErrors.override_reason}
											</Form.Control.Feedback>
										</Form.Group>

										<div className="d-flex gap-2 justify-content-end mt-4">
											<Button
												variant="secondary"
												onClick={this.handleSkipOverrideModal}
												disabled={this.state.overrideLoading}
											>
												Skip
											</Button>
											{/* {this.state.overrideAllowCancel && ( */}
											{/* <Button
											variant="secondary"
											onClick={this.hideOverrideModal}
											disabled={this.state.overrideLoading}
										>
											Cancel
										</Button> */}
											{/* )} */}
											{/* <Button
										variant="danger"
										onClick={this.closeBusinessDay}
										disabled={this.state.overrideLoading}
									>
										<FontAwesomeIcon icon={faTimesCircle} className="me-2" />
										Close Business Day
									</Button> */}
											<Button
												variant="primary"
												onClick={this.handleOverrideSubmit}
												disabled={this.state.overrideLoading}
											>
												{this.state.overrideLoading ? (
													<>
														<div className="spinner-border spinner-border-sm me-2" role="status">
															<span className="visually-hidden">Loading...</span>
														</div>
														Extending...
													</>
												) : (
													<>
														<FontAwesomeIcon icon={faClock} className="me-2" />
														Extend Time
													</>
												)}
											</Button>
										</div>
									</Form>
								</div>
							}
						/>
					)}

					{this.state.businessdayConfirmModal && (
						<ModalGlobal
							show={this.state.businessdayConfirmModal}
							onHide={this.cancelCloseBusinessDay}
							className="modalcustomizeDialog confirmationalertmodalDialog"
							bodyClassName="cancelConfirmationbody"
							headerclassName="close_btn_icon"
							title="Close Business Day"
							footer={false}
							body={
								<ConfirmationAlert
									BodyFirstContent={this.state.businessDayConfirmMessage}
									confirmationButtonContent="Confirm"
									deleteConfirmButton={this.executeCloseBusinessDay}
									cancelButtonContent="Cancel"
									deleteCancleButton={this.cancelCloseBusinessDay}
								/>
							}
						/>
					)}

					{/* PMS Sync Confirmation Modal */}
					{this.state.showPmsSyncModal && (
						<ErrorBoundary title="ModalGlobal Error">
							<ModalGlobal
								show={this.state.showPmsSyncModal}
								onHide={this.handleClosePmsSyncModal}
								className="modalcustomize confirmationalertmodalDialog"
								bodyClassName="cancelConfirmationbody"
								headerclassName="close_btn_icon"
								title="Confirm Sync With PMS"
								footer={false}
								body={
									<ErrorBoundary title="ConfirmationAlert Error">
										<ConfirmationAlert
											BodyFirstContent="Are you sure you want to sync Category & Product with PMS?"
											// BodySecondContent="This will initiate a full sync between POS and PMS."
											BodyThirdContent=""
											confirmationButtonContent="Yes"
											cancelButtonContent="No"
											deleteConfirmButton={this.handleConfirmPmsSync}
											deleteCancleButton={this.handleClosePmsSyncModal}
										/>
									</ErrorBoundary>
								}
							/>
						</ErrorBoundary>
					)}

					{/* Read All Notifications Confirmation Modal */}
					{this.state.showReadAllConfirmModal && (
						<ModalGlobal
							show={this.state.showReadAllConfirmModal}
							onHide={this.cancelReadAllConfirmModal}
							className="modalcustomizeDialog confirmationalertmodalDialog"
							bodyClassName="cancelConfirmationbody"
							headerclassName="close_btn_icon"
							title="Mark All as Read"
							footer={false}
							body={
								<ConfirmationAlert
									BodyFirstContent="Are you sure you want to mark all notifications as read?"
									confirmationButtonContent="Yes"
									cancelButtonContent="No"
									deleteConfirmButton={this.confirmReadAllNotifications}
									deleteCancleButton={this.cancelReadAllConfirmModal}
								/>
							}
						/>
					)}

					{/* Pending Orders Modal */}
					<Modal
						show={this.state.showPendingOrdersModal}
						onHide={this.handleCancelPendingOrders}
						backdrop="static"
						keyboard={false}
					>
						<Modal.Header closeButton>
							<Modal.Title>Close Day</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							Please settle all pending orders before closing the day.
						</Modal.Body>
						<Modal.Footer>
							<Button variant="secondary" onClick={this.handleCancelPendingOrders}>
								Dismiss
							</Button>
							<Button variant="primary" onClick={this.handleGoToTableView}>
								Sure
							</Button>
						</Modal.Footer>
					</Modal>

					<OpenRegistersCloseModal
						show={this.state.showOpenRegistersModal}
						registers={this.state.openRegistersList}
						onCancel={this.cancelOpenRegistersModal}
						onConfirm={this.confirmAutoCloseRegisters}
						loading={this.state.autoClosingRegisters}
					/>

					{/* Advance Night Audit Checkpoints Modal */}
					<NightAuditCheckpointsModal
						show={this.state.showNightAuditModal}
						onHide={() => this.setState({ showNightAuditModal: false })}
						checkpointsData={this.state.nightAuditCheckpointsData}
						loading={this.state.nightAuditLoading}
						onRefresh={this.openNightAuditModal}
						onConfirmClose={this.handleNightAuditConfirmClose}
						closing={this.state.nightAuditClosing}
						onGoToTableView={this.handleGoToTableView}
						onGoToOrderList={() => {
							this.setState({ showNightAuditModal: false });
							if (this.props.history) {
								this.props.history.push('/en-US/orders');
							}
						}}
						onGoToDigitalOrders={() => {
							this.setState({ showNightAuditModal: false });
							const lng = localStorage.getItem('i18nextLng') || 'en-US';
							if (this.props.history) {
								this.props.history.push(`/${lng}/sales/digital-menu-orders`);
							}
						}}
					/>

					{/* Close Register Modal */}
					<CloseRegisterModal
						t={this.props.t}
						show={this.state.showCloseRegisterModal}
						onHide={(registerClosedSuccessfully) => {
							this.handleCloseRegisterModalHide(registerClosedSuccessfully || false);
						}}
						mode={this.state.closeRegisterMode}
						registerData={this.state.registerData}
					/>

					<ErrorBoundary title="ModalGlobal Error">
						<ModalGlobal
							show={this.state.showOpenBusinessDayModal}
							onHide={this.closeOpenBusinessDayModal}
							className="modalcustomize confirmationalertmodalDialog"
							bodyClassName="cancelConfirmationbody"
							headerclassName="close_btn_icon"
							title="Open Business Day"
							footer={false}
							body={
								<>
									<ErrorBoundary title="ConfirmationAlert Error">
										<ConfirmationAlert
											BodyFirstContent="Are you sure you want to open the business day?"
											BodySecondContent=""
											BodyThirdContent=""
											confirmationButtonContent="Yes"
											cancelButtonContent="No"
											deleteConfirmButton={this.confirmOpenBusinessDay}
											deleteCancleButton={this.closeOpenBusinessDayModal}
										/>
									</ErrorBoundary>
								</>
							}
						/>
					</ErrorBoundary>

				</header>
			</div>
		)
	}

};

const mapStateToProps = (globalState) => {
	return {
		userCredentials: globalState.LoginReducer.userCredentials,
		accessToken: globalState.LoginReducer.accessToken,
		token: globalState.LoginReducer.token,
		refreshToken: globalState.LoginReducer.refreshToken,
		expiresIn: globalState.LoginReducer.expiresIn,
		crossPanelAccess: globalState.LoginReducer.crossPanelAccess,
		userGroup: globalState.LoginReducer.userGroup,
		organisationGroup: globalState.LoginReducer.organisationGroup,
		userEntryType: globalState.LoginReducer.userEntryType,
		leftbar: globalState.mainReducerData.leftbar,
		skipBusinessDayOverrideWarningFlag: globalState.mainReducerData.skipBusinessDayOverrideWarning,
		currentStore: globalState.StoreReducer.currentStore,
		storesFetched: globalState.StoreReducer.storesFetched,
		stores: globalState.StoreReducer.stores,
	};
}

export default connect(mapStateToProps, { handleLeft, loaderStateTrue, loaderStateFalse, skipBusinessDayOverrideWarning, setToken, setUserEntryType, setUserCredentials, logOutApp, setCurrentStore, setStoresFetched, setStores })(withNamespaces()(withRouter(Header)));